{
  "(MitDiesemGeschäftGeschlossen)": "(Clôturé avec cette affaire)",
  "(mit Ertragswertkomponente)": "(y c. la composante de la valeur de rendement)",
  "ABBRUCH": "Interruption",
  "ABGEBROCHEN": "Interrompu(e)",
  "ABGESCHLOSSEN_MIT_GRUNDBUCH": "Clôturé avec registre foncier",
  "ABGESCHLOSSEN_OHNE_GRUNDBUCH": "Clôturé sans registre foncier",
  "ABGEWIESEN": "Rejeté",
  "ABGEWIESEN_AUSGETRAGEN": "Rejetée et déchargée",
  "ABSCHLUSS": "Clôture",
  "ACI": "ACI",
  "ACKER_WIESE_PFLANZLAND_BAUMGARTEN_BISHER": "Champ, pré, verger, terrain maraîcher",
  "ADG": "ADG",
  "ADG_lang": "Ancien droit Genevois",
  "AHV-Nr/UID": "N° AVS / IDE",
  "AHVNummer": "No AVS (ancien)",
  "AHVVersichertennummer": "No AVS",
  "AKUTSPITAELER_ALLGEMEINE_SPITAELER": "Hôpital de soins intensifs, hôpitaux généraux",
  "ALLE": "Tous",
  "ALLEINEIGENTUM": "Propriété individuelle",
  "ALLE_PERSON": "Tous",
  "ALTRECHTLICH": "Selon l'ancien droit",
  "AMWARTEN": "En attente",
  "ANDERE": "autre remarque MO",
  "ANDEREADRESSE": "Autre adresse",
  "ANDEREART": "Autre genre",
  "ANDEREROLLE": "autre rôle",
  "ANDERE_BEHERBERGUNGEN": "Autres types d'hébergement",
  "ANDERE_GEBAEUDE_FUER_DIE_KOLLEKTIVE_UNTERKUNFT": "Autres bâtiments d'hébergement collectif",
  "ANDERE_GEBAEUDE_FUER_KURZFRISTIGE_BEHERBERGUNGEN": "Autres bâtiments pour hébergement de courte durée",
  "ANDERE_LANDWIRTSCHAFTLICHE_GEBAEUDE": "Autres bâtiments agricoles",
  "ANDERE_WOHNGEBAEUDE": "Autres bâtiments résidentiels (bâtiments résidentiels à usage secondaire)",
  "ANMERKUNG": "Mention",
  "ANMERKUNG_KURZ": "Men",
  "ANREDE": "Titre",
  "AUFGABE": "Tâche",
  "AUFGEHOBEN": "Supprimé",
  "AUFGELOESTEPARTNERSCHAFT": "Partenariat dissous",
  "AUSLAENDISCHE_GEMEINDE": "Etranger/étrangère",
  "AUSLAENDISCHE_RECHTSFORM": "Forme juridique étrangère",
  "AV-Mutation": "Mutation MO",
  "AV-Mutationsnummer": "No de mutation",
  "AV_BEMERKUNG": "Observation MO",
  "AW": "EF",
  "AW: ": "VO : ",
  "Abbrechen": "Annuler",
  "Abbruchjahr": "Année de la démolition",
  "Ablaufdatum": "Date d'échéance",
  "Abschluss (Rechtsgültigsetzung)": "Date de validation",
  "Abschlussdatum": "Date de validation",
  "Abschnittflaeche": "Surface partielle",
  "AdminNr": "No d' administration",
  "AdminWohnungsnummer": "Admin. no d'appartement",
  "Adresse": "Adresse",
  "AdresseEingang": "Adresse / entrée",
  "AdresseKopieren": "Copier l'adresse dans le presse-papier",
  "AdresseWurdeKopiert": "L'adresse a été copiée dans le presse-papier",
  "Adressen": "Adresses",
  "AdressenAufbereiten": "Préparer adresses",
  "AdressenN": "Adresse(s)",
  "AktenempfaengerFreitext": "Destinataire texte libre",
  "Aktueller Betrachtungskontext": "Contexte d'affichage actuel",
  "Alle": "Tous",
  "Alleineigentum": "Propriété individuelle",
  "Alpgrundstuecke": "Immeubles d'alpage",
  "AlteIdentifikation": "Ancienne identification",
  "AmtlicheBaudossiernummer": "No du dossier officiel de construction",
  "AmtlicheBaudossiernummerZusatz": "No du dossier officiel de construction, complément",
  "AmtlicheBewertung": "Valeur officielle",
  "AmtlicherWert": "Valeur officielle",
  "AngefordertenRessourceWurdeNeueUriZugewiesen": "La ressource demandée s'est vu attribuer une nouvelle URI permanente.",
  "Anmelder": "Personne requérante",
  "AnmelderText": "Personne requérante texte",
  "Anmerkung": "Mention",
  "AnmerkungAmtlicheVermessung": "Observations MO",
  "Anmerkungen": "Mentions",
  "Anmerkungsgrundstueck": "Immeuble dépendant",
  "Annulliert": "Annulé",
  "Anrede": "Salutation",
  "Anteil": "Part",
  "AnteilAmDominiertenGrundstueck": "Part de l’immeuble dépendant",
  "AnteilAmStammgrundstueck": "Part de l'immeuble de base",
  "AnteilEigentum": "Part de propriété",
  "AnzahlGebaeude": "Nombre de bâtiments concernés",
  "AnzahlGeschosse": "Nombre d'étages",
  "AnzahlWohnraeume": "Nombre de pièces d'habitation particulières",
  "AnzahlWohnungen": "Nombre d'appartements",
  "AnzahlZimmer": "Nombre de chambres",
  "Anzeige": "Affichage",
  "AnzeigeBauprojekt": "Affichage projet de construction",
  "AnzeigeGebäude": "Afficher détails pour les bâtiments",
  "AnzeigeWohnung": "Afficher les détails de l'appartement",
  "Art": "Genre",
  "ArtDerArbeiten": "Type de travaux",
  "ArtDerBauwerke": "Type de bâtiments",
  "AufbereitungsoptionenEigentuemerAuszug": "Options de préparation pour l'extrait de propriétaires",
  "AufbereitungsoptionenGrundstueckAuszug": "Options de préparation pour l'extrait d'immeubles",
  "AufbereitungsoptionenRechteAuszug": "Options de préparation pour l'extrait des droits",
  "Aufklappen": "ouvrir",
  "Auftraege": "Mandats",
  "Auftrag": "Ordre",
  "Auftrag senden": "Envoyer l'ordre",
  "Auftrag.SucheTitel": "Recherche des ordre",
  "AuftragLoeschen": "Supprimer l'ordre",
  "AuftragMitNummerErfolgreichErstellt": "Un ordre du numéro {{auftragsNummer}} a été créé avec succès",
  "AuftraggeberFreitext": "Mandant, texte libre",
  "Auftrags-Nr": "Numéro de la commande",
  "AuftragsNr": "Numéro",
  "AuftragsNummerAblage": "N° de la commande / d’archivage",
  "AuftragsTyp": "Type de commande",
  "Auftragsdatum": "Date du mandat",
  "Ausgang": "Sortie",
  "AusserbuchlicherUebergang": "Transfert hors registre",
  "Auswahl": "Sélection",
  "Auszug": "Extrait",
  "AuszugBearbeiten": "Modifier l'extrait",
  "AuszugErstellen": "Créer extrait",
  "AuszugZuANMERKUNGErstellen": "Créer extrait pour mention {{param}}",
  "AuszugZuDIENSTBARKEITErstellen": "Créer extrait pour servitude {{param}}",
  "AuszugZuEIGENTUMANTEILErstellen": "Créer extrait pour part de propriété {{param}}",
  "AuszugZuEigentuemerErstellen": "Créer extrait du propriétaire {{param}} pour",
  "AuszugZuGRUNDLASTErstellen": "Créer extrait pour charge foncière {{param}}",
  "AuszugZuGrundbuchmeldungErstellen": "Etablir extrait pour avis RF",
  "AuszugZuGrundstueckErstellen": "Créer extrait pour immeuble {{param}}",
  "AuszugZuPFANDRECHTErstellen": "Créer extrait pour droit de gage {{param}}",
  "AuszugZuRechtErstellen": "Créer extrait pour droit {{param}}",
  "AuszugZuSDR_DIENSTBARKEITErstellen": "Créer extrait pour servitude DDP {{param}}",
  "AuszugZuVORMERKUNGErstellen": "Créer extrait pour annotation {{param}}",
  "Auszüge": "Extrait",
  "AvBemerkung": "Remarque MO",
  "AvMutation": "Mutation MO",
  "BAHNANLAGEN": "Infrastructures ferroviaires",
  "BAHNEN_STRASSEN_WEGE_BISHER": "Chemin de fer, route, chemin",
  "BAHNHOEFE_ABFERTIGUNGSGEBAEUDE_FERNSPRECHVERMITTLUNGSZENTRALEN": "Gares, aérogares, échanges téléphoniques",
  "BAUBEWILLIGUNG_BEWILLIGT": "Permis de construction accordé",
  "BAUGESUCH_ABGELEHNT": "Demande de construction refusé",
  "BAUGESUCH_BEANTRAGT": "Demande de construction requise",
  "BAURECHT": "Droit de superficie",
  "BE-EDID": "BE-EDID",
  "BEARBEITET": "Traité",
  "BEARBEITUNG": "En traitement",
  "BEFESTIGT_BAHN": "Chemin de fer",
  "BEFESTIGT_FLUGPLATZ": "Aérodrome",
  "BEFESTIGT_STRASSE_WEG": "Route, chemin",
  "BEFESTIGT_TROTTOIR": "Trottoir",
  "BEFESTIGT_UEBRIGE_BEFESTIGTE": "Autre surface à revêtement dur",
  "BEFESTIGT_VERKEHRSINSEL": "Îlot",
  "BEFESTIGT_WASSERBECKEN": "Bassin",
  "BEHAELTER_SILOS_UND_LAGERGEBAEUDE": "Conteneurs, silos et bâtiments de stockage",
  "BELASTET": "Grevé(e)",
  "BELASTET_BERECHTIGT": "Grevé(e)/bénéficiaire",
  "BERECHTIGT": "Bénéficiaire",
  "BEREINIGUNG": "Epuration",
  "BEREITZURUEBERNAHME": "Prêt pour la reprise",
  "BEREIT_FUER_GRUNDBUCH": "Prêt pour registre foncier",
  "BEREIT_FUER_KORREKTURLIEFERUNG": "Prêt pour correction",
  "BEREIT_FUER_TAGEBUCH": "Prêt pour le journal",
  "BEREIT_FUER_VERARBEITUNG": "Prêt pour traitement",
  "BEREIT_ZUR_VERIFIKATION": "Prêt pour vérification",
  "BERGWERK": "Mine",
  "BERGWERK_ausg": "Mine",
  "BESTEHEND": "Existant",
  "BESTOCKT_GESCHLOSSENER_WALD": "Forêt dense",
  "BESTOCKT_UEBRIGE_BESTOCKTE": "Autre surface boisée",
  "BESTOCKT_WYTWEIDE_WYTWEIDE_DICHT": "Pâturage boisé dense",
  "BESTOCKT_WYTWEIDE_WYTWEIDE_OFFEN": "Pâturage boisé ouvert",
  "BEWERTUNGSGRUND": "Cause de l'évaluation",
  "BEWILLIGT": "accordé",
  "BODENBEDECKUNG": "Couverture du sol",
  "BUEROGEBAEUDE": "Immeuble de bureaux",
  "BUEROGEBAEUDE_VERWALTUNGSGEBAEUDE": "Immeuble de bureaux, bâtiment administratif",
  "BUS_TRAMANLAGEN": "Systèmes de bus et de tramway",
  "Bauart": "Type de construction",
  "Baueingabe": "Demande de construction",
  "BaugesuchAbgelehnt": "Demande de construction refusé",
  "BaugesuchBeantragt": "Demande de construction déposée",
  "BaugesuchBewilligt": "Demande de construction autorisée",
  "Baujahr": "Année de construction",
  "Bauort": "Lieu de construction",
  "BauortMussVorhandenSein": "L'organe d'enquète doit être présent",
  "Bearbeiter": "Chargé(e) d'affaire",
  "Bearbeitet": "Traité",
  "Bearbeitungsstatus": "Statut de traitement",
  "Belastet": "C",
  "BelastetBerechtigt": "Ch/D",
  "BelastetMit": "Grevé par DDP",
  "BelastetOderBerechtigt": "Immeubles grevés",
  "BelasteteTeilflaechen": "Surfaces partielles grevées",
  "Belastung": "Charge",
  "Beleg": "Pièce justificative",
  "BelegAlt": "PJ ancienne",
  "Belegamt": "Bureau de la PJ",
  "Belegdatum": "Date d'origine",
  "BelegeZuGrundbuchgeschäft": "PJ pour affaire du RF ",
  "Bemerkung": "Observation",
  "BemerkungGrundbuch": "Observations RF",
  "Bemerkungen": "Observations",
  "Berechtigt": "D",
  "BerechtigtAn": "Ayant droit à ",
  "BerechtigtePersonen": "Personnes bénéficiaires",
  "Bereinigungsmarkierung": "Marque de révision",
  "BereitFuerGrundbuch": "Date prêt pour RF",
  "BereitfürGrundbuch": "Prêt pour registre foncier",
  "Beschreibung": "Descriptif",
  "BeteiligteGrundstuecke": "Immeubles impliqués",
  "BetroffeneGebäude": "Bâtiments concernés",
  "BetroffeneGemeinden": "Communes impliquées",
  "BetroffeneGrundstücke": "Immeubles concernés",
  "Bewertung": "Valeur",
  "Bezeichnung": "Désignation",
  "BezugZumGrundbuch": "Référence au registre foncier",
  "Bodenbedeckung": "Couverture du sol",
  "BodenbedeckungGeschichte": "prendre en compte l'historique",
  "CFA": "CFA",
  "CFA_lang": "Construction",
  "CSV": "CSV",
  "Close": "Fermer",
  "CodeGläubiger": "Code créancier/ière",
  "CodeNachRechtart": "Code selon le type de droit",
  "CodeSchuldner": "Code débiteur/débitrice",
  "DEFAULT_MIT_GRUNDBUCH": "Affaire standard avec registre foncier",
  "DEFAULT_OHNE_GRUNDBUCH": "Affaire standard sans registre foncier",
  "DEFINITIV": "Définitif",
  "DENKMAELER_ODER_UNTER_DENKMALSCHUTZ_STEHENDE_BAUWERKE": "Monuments ou édifices classés",
  "DIENSTBARKEIT": "Servitude",
  "DIENSTBARKEIT_GRUNDLAST": "Charge foncière",
  "DIENSTBARKEIT_KURZ": "SE",
  "DOMINANTINDENT": "DOMINANTINDENT",
  "DOMINANTINDET": "Dominantindet",
  "DPI": "DPI",
  "DPI_lang": "Domaine public immatriculé",
  "DRINGEND": "Urgent",
  "DarinEnthalteneZugaben": "Accessoires inclus",
  "Dateiformat": "Format du fichier",
  "Datenquelle": "Source des données",
  "Datenschutzbereinigt": "Conforme à la protection des données",
  "Datum": "Date",
  "Datum Auftrag": "Date de la commande",
  "DatumAuftrag": "Date commande",
  "DatumBaubeginn": "Date du début des travaux",
  "DatumBaubewilligung": "Date du permis de construction",
  "DatumBauende": "Date de la fin des travaux",
  "DatumBis": "jusqu'au",
  "DatumDesExports": "date d'exportation",
  "DatumEingabe": "Date de publication",
  "DatumEingabeFehler": "La durée peut s'élever au maximum à {{tage}} jours",
  "DatumEntstehung": "Date de création",
  "DatumEntstehungErgänzung": "Date de (création/complément)",
  "DatumJahrEingabeFormatBeispiel": "aaaa",
  "DatumMonatEingabeFormatBeispiel": "mm",
  "DatumNutzenUndGefahr": "Date profits et risques",
  "DatumOderBeleg": "Date/PJ",
  "DatumOderBelegOderEntstehung": "Date/PJ Constitution",
  "DatumOderBelegOderRechtsgrund": "Date/PJ/Titre de droit",
  "DatumOderEntstehungOderRechtsgrund": "Date/Pièce justificative/Titre de droit",
  "DatumProjekteingabe": "Requète de construire",
  "DatumRechtsgrund": "Date du titre de droit",
  "DatumTagEingabeFormatBeispiel": "jj",
  "DatumVertragsabschluss": "Date de conclusion de contrat",
  "DatumVon": "du",
  "DerServerMeldetEinenTechnischenFehler": "Le serveur signale une panne technique (HTTP {{status}})",
  "Detaillierungsgrad": "Degré de détail",
  "DetailsZuArtAnzeigen": "Afficher détails pour {{art}}",
  "DetailsZuGebaeudeWohnungsregister": "Détails du Registre des bâtiments/logements",
  "DetailsZuGrundstueckAusSichtGrundbuch": "Détails sur l'immeuble du point de vue du registre foncier",
  "DetailsZuGwrGebäude": "Détails sur le bâtiment RegBL",
  "DetailsZumGeschaeftAnzeigen": "Afficher détails de l'affaire",
  "DetailsZumLöschgeschaeftAnzeigen": "Afficher détails du n° de radiation",
  "Dienstbarkeit": "Servitude",
  "DienstbarkeitDetail": "Détail de la servitude",
  "Dienstbarkeiten": "Servitudes",
  "Dokumente": "Documents",
  "DokumenteZuAlteGrundbuchmeldung": "Anciens avis du registre foncier pour affaire {{param}}",
  "DokumenteZuBeleg": "Document pour PJ {{param}}",
  "DokumenteZuGeschaeft": "Document pour affaire {{param}}",
  "DokumenteZuGrundstueck": "Document pour immeuble {{param}}",
  "DokumenteZuRecht": "Document pour droit {{param}}",
  "DominantIndet": "DI",
  "DominierendeGrundstuecke": "Immeubles dominés",
  "DominierteGrundstuecke": "Immeubles dépendants",
  "Dossiernummer": "No du dossier",
  "DossiernummerdSuche": "DossiernummerdSuche",
  "EBelege": "PJ électroniques",
  "EDID": "EDID",
  "EGBPID": "EGBPID",
  "EGBTBID": "EGBTBID",
  "EGBTBIDSuche": "Recherche EGBTBID",
  "EGID": "EGID",
  "EGID_EWID": "EGID / EWID",
  "EGRID": "E-GRID",
  "EGVAnmeldung": "eGV Inscription",
  "EIDGENOESSISCH": "fédérale",
  "EIGENTUEMER": "Propriétaires",
  "EINFACHEGESELLSCHAFT": "Société simple",
  "EINFAMILIENHAEUSER": "Maisons individuelles",
  "EINFAMILIENHAEUSER_ANGEBAUT": "Maisons individuelles ajoutées",
  "EINFAMILIENHAEUSER_FREISTEHEND": "Maisons individuelles",
  "EINFUEHRUNG": "Introduction RFF en cours",
  "EINGEDOLTES_GEWAESSER": "Eau canalisée",
  "EINMALIG": "Une fois",
  "EINZELPFANDRECHT": "Droit de gage individuel",
  "EINZELPFANDRECHT_KURZ": "I",
  "ELEKTRIZITAETSWERKE_NETZE": "Centrales et réseaux électriques",
  "EPROID": "EPROID",
  "ERBENGEMEINSCHAFT": "Communauté héréditaire",
  "EREID": "EREID",
  "EROEFFNET": "Ouvrir",
  "ERSTERHEBUNG_ERNEUERUNG": "Premier relevé / renouvellement",
  "ERWERBER": "acquéreur",
  "EW": "VR",
  "EXMATRIKULIERT": "Exmatriculée",
  "EXTERNER_HINWEIS": "Indication externe",
  "EgbpidSuche": "Recherche EGBPID",
  "EgbtbidSuche": "Recherche EGBTBID",
  "EgidSuche": "Recherche EGID",
  "EgridSuche": "Recherche EGRID",
  "EgvtBelege": "PJ eGV",
  "Eigentuemer": "Propriété",
  "Eigentum": "Propriété",
  "EigentumErweitern": "Élargir la propriété",
  "EigentumExportieren": "Exporter la propriété",
  "Eigentumsform": "Forme de propriété",
  "Eigentumsform.ALLEINEIGENTUM": "Propriété individuelle",
  "Eigentumsform.GESAMTEIGENTUM": "Propriété commune",
  "Eigentumsform.MITEIGENTUM": "Copropriété",
  "EigentümerBisher": "Auparavant propriété de",
  "EigentümerMitAdresseAufbereiten": "Préparer propriétaire avec adresse",
  "EigentümerNeu": "Nouveau(x) propriétaire(s)",
  "Eigentümerauszug": "Extrait de propriétaire",
  "EinTechnischerFehlerIstAufgetreten": "Une panne technique s'est produite.",
  "EingabeDarfNichtLeerSein": "L'entrée doit être disponible",
  "EingabeGemeindeErforderlich": "L'entrée d'une municipalité est requise",
  "EingabeGrundbuchamtErforderlich": "L'entrée doit être un bureau du registre foncier valide",
  "EingabeIstZuLange": "L'entrée est trop longue",
  "EingabeMussFolgendesFeldAngegebenHaben": "\"{{Feld}}\" doit être spécifié",
  "EingabeMussGenauEineGemeindeAusgewaehltHaben": "Une seule commune doit être sélectionnée",
  "EingabeMussGueltigeHaunsummerSein": "L'entrée doit être un numéro de maison valide (p.ex. 2a)",
  "EingabeMussGueltigeStrasseSein": "L'entrée doit contenir au moins 2 caractères",
  "EingabeMussJahrSein": "L'entrée doit être l'année avec 4 chiffres",
  "EingabeMussMindestensEinGrundstueckTypAusgewaehltHaben": "Au moins un type de l'immeuble doit être sélectionné",
  "EingabeMussMindestensEineBodenbedeckungAusgewaehltHaben": "Au moins une couverture du sol doit être sélectionnée",
  "EingabeMussMindestensEineGrundstueckbeschreibungHaben": "Au moins une description de l'immeuble doit être sélectionnée",
  "EingabeMussMindestensEinePersonenartAusgewaehltHaben": "Au moins un type de personne doit être sélectionné",
  "EingabeMussMindestensEineRechteArtAusgewaehltHaben": "Au moins un type de droit doit être sélectionné",
  "EingabeMussMindestensEineRubrikAusgewaehltHaben": "Au moins une rubrique doit être sélectionnée",
  "EingabeMussValideAHVNummerSein": "L'entrée doit être N° AVS valide",
  "EingabeMussValideBaudossiernummerSein": "L'entrée doit être un numéro de dossier de construction valide",
  "EingabeMussValideEgbpidSein": "L'entrée doit être une EGBPID valide (p.e. CH123577617789)",
  "EingabeMussValideEgbtbidSein": "L'entrée doit être une EGBTBID valide (p.e. CH123577617789)",
  "EingabeMussValideEgidSein": "L'entrée doit être une EGID valide",
  "EingabeMussValideEgridSein": "L'entrée doit être une E-GRID valide",
  "EingabeMussValideEmailSein": "L'entrée doit être un e-mail valide",
  "EingabeMussValideEproidSein": "L'entrée doit être une EPROID valide",
  "EingabeMussValideEreidSein": "L'entrée doit être une EREID valide",
  "EingabeMussValideGrundstueckNummerSein": "L'entrée doit être un numéro de l'immeuble valide",
  "EingabeMussValideNummerSein": "L'entrée doit être un chiffre",
  "EingabeMussValideNummerSein-EGID": "L'entrée doit être un chiffre. Attention: on attend ici un EGID (identificateur fédéral de bâtiment) et non pas un E-GRID (identification fédérale des immeubles).",
  "EingabeMussValideNummerSein5Stellen>80k": "Pour la recherche de droits spéciaux, un numéro à 5 chiffres > 80000 doit être saisi",
  "EingabeMussValideNummerSeinBeispiel": "L'entrée doit être un chiffre dans la forme 2018",
  "EingabeMussValidePLZSein": "L'entrée doit être un code postal valide",
  "EingabeMussValideUIDSein": "L'entrée doit être IDE valide",
  "EingabeMussValideVersicherungsNummerSein": "L'entrée doit être un numéro d'assurance valide",
  "EingabeMussValiderBaudossiernummerZusatzSein": "L'entrée doit être un numéro complémentaire de dossier de construction valide",
  "EingabeMussValiderMonatSein": "Must be a valid month",
  "EingabeMussValiderTagSein": "L'entrée doit être un jour valide",
  "EingabeMussValidesDatumSeinBeispiel": "L'entrée doit être une date dans la forme 31.12.2018",
  "EingabeMussValidesJahrSein": "L'entrée doit être une année valide",
  "EingabeNichtValide(1-30Zeichen)": "L'entrée n'est pas valide (doit contenir 1-30 caractères)",
  "EingabeUploadFileNichtValidOderNameExistiert": "Le nom du fichier existe déjà dans le système ou les lignes suivantes dans le fichier d’entrée ne correspondent pas au format demandé",
  "Eingang": "Entrée",
  "Eingangsdatum": "Date d'entrée",
  "Einstellungen": "Calibrage",
  "EinstellungenSpeichernBisZurNaechstenAbmeldung": "Sauvegarder calibrage (jusqu'à la prochaine déconnexion)",
  "EinstellungenZuruecksetzen": "Réinitialiser calibrage",
  "Eintraege": "inscriptions",
  "Eintrag": "inscription",
  "Eintragung": "Inscription",
  "EintragungenImGrundbuch": "Inscriptions au registre foncier",
  "Einzelobjekt": "Objet divers",
  "EinzelobjektAbkürzung": "OD",
  "Enddatum": "Date de la fin",
  "EnthalteneZugaben": "Accessoires inclus",
  "Entschädigung": "Prix de vente",
  "EntstandenAus": "Créé(e) à partir de",
  "Entstehungsdatum": "Date de création",
  "EproidSuche": "Recherche EPROID",
  "EreidSuche": "Recherche EREID",
  "EreidsAufbereiten": "Préparer les EREIDs",
  "ErgebnisoptionenEigentum": "Propriété",
  "ErgebnisoptionenGrundstueckbeschreibung": "Description de l'immeuble RF",
  "ErgebnisoptionenStammperson": "Personne de base",
  "ErrorGettingMap": "Erreur lors du chargement du plan",
  "ErrorWhileLoading": "Une erreur s'est produite lors du traitement de la requête. Les données affichées peuvent être incomplètes. Veuillez réessayer plus tard.",
  "Erstelldatum": "Date de création",
  "ErstelltMit": "Créé(e) avec",
  "ErstelltVon": "créé par",
  "Ersterfassung": "Saisie initiale",
  "ErsterfassungÜbergeben": "R:Transférer saisie initiale",
  "Erweitert": "Etendu",
  "ErweiterteSuche": "Recherche étendue",
  "Erwerber": "Aquéreur",
  "Erwerbsangaben": "Informations d'acquisition",
  "Export": "Exportation",
  "FAUSTPFANDGLAEUBIGER": "Créancier/ière de nantissement",
  "FEHLERHAFT": "Échoué",
  "FEHLERLOS": "Réussi",
  "FERNHEIZUNGSANLAGEN": "Systèmes de chauffage urbain",
  "FLAECHENBERICHTIGUNG": "Correction de la superficie",
  "FLUGVERKEHRSANLAGEN": "Installations de circulation aérienne",
  "FLURNAME": "Nom local",
  "FOLIO": "Folio",
  "FOLIO_ausg": "Folio",
  "FORSTWIRTSCHAFTSBAUTEN": "Bâtiments d'exploitation forestière",
  "FREIZEIT_TOURISMUSANLAGEN": "Infrastructures de loisirs et de tourisme",
  "FUNKTION_BENUTZER": "Fonction de l'utilisateur",
  "FehlerBeimAufrufDesWebservice": "Erreur lors de l'appel du service web",
  "Fehlermeldungen": "Exceptions de l'exportation",
  "Flaeche": "Surface",
  "FlaecheNichtAusgeschieden": "Pas défini en terme de surface",
  "FlaecheWertquote": "Surface / Quote-part",
  "Flaechenanteile": "Parts de surface DDP",
  "Flurname": "Nom local",
  "Folio": "Folio",
  "FormDerFuehrung": "Forme de registre foncier",
  "FremdId": "ID externe",
  "FremdeIdentifikation": "ID externe",
  "Fremdsystem": "Système externe",
  "FremdsystemFehler": "Un système externe ne peut pas fournir de données pour cette demande pour le moment.",
  "FremdsystemNeskoFehler": "Une erreur est survenue lors de l'appel de Nesko AB.",
  "GARAGENGEBAEUDE": "Bâtiment du garage",
  "GARAGEN_PARKPLAETZE_EINSTELLHALLEN_IM_ZUSAMMENHANG_MIT_WOHNGEBAEUDEN": "Garages, places de parking, halls de stationnement en relation avec des immeubles d'habitation",
  "GASWERKE_NETZE_CHEMISCHE_ANLAGEN": "Usines et réseaux de gaz, usines chimiques",
  "GB_AUSZUG_LIG": "Extrait du registre foncier bien-fonds",
  "GB_AUSZUG_MIT": "Extrait du registre foncier copropriété",
  "GB_AUSZUG_SDR": "Extrait du registre foncier DDP",
  "GB_AUSZUG_SEYBUCH": "Extrait du registre foncier registre des droits d'alpage",
  "GB_AUSZUG_STW": "Extrait du registre foncier propriété par étages",
  "GB_DETAIL_PFANDRECHT": "Aperçu du registre des droits droit de gage",
  "GB_DETAIL_STANDARDRECHT": "Aperçu du registre des droits droit standard",
  "GB_GEMEINDEKREIS": "Numéro d'arrondissement",
  "GB_GEMEINDE_OHNEKREIS": "Commune",
  "GB_UEBERSICHT_LIG": "Aperçu du registre bien-fonds",
  "GB_UEBERSICHT_MIT": "Aperçu du registre foncier copropriété",
  "GB_UEBERSICHT_SDR": "Aperçu du registre foncier DDP",
  "GB_UEBERSICHT_STW": "Aperçu du registre foncier propriété par étages",
  "GEBAEUDE": "Bâtiment(s)",
  "GEBAEUDEKATEGORIE": "Catégorie de bâtiment",
  "GEBAEUDEKLASSE": "Type de bâtiment",
  "GEBAEUDESTATUS": "Statut du bâtiment",
  "GEBAEUDE_FUER_DEN_PFLANZENBAU": "Bâtiment de production de plantes",
  "GEBAEUDE_FUER_DIE_TIERHALTUNG": "Bâtiments abritant des animaux",
  "GEBAEUDE_FUER_KULTUR_UND_FREIZEITZWECKE": "Bâtiments culturels et récréatifs",
  "GEBAEUDE_HOFRAUM_GARTEN_ANLAGE_BISHER": "Bâtiment, cour, jardin, installation",
  "GEBAEUDE_MIT_AUSSCHLIESSLICHER_WOHNNUTZUNG": "Bâtiment à usage d'habitation exclusif",
  "GEBAEUDE_MIT_DREI_ODER_MEHR_WOHNUNGEN": "Bâtiment de trois appartements ou plus",
  "GEBAEUDE_MIT_EINER_WOHNUNG": "Bâtiment avec un appartement",
  "GEBAEUDE_MIT_TEILWEISER_WOHNNUTZUNG": "Bâtiment à usage d'habitation partiel",
  "GEBAEUDE_MIT_ZWEI_WOHNUNGEN": "Bâtiment avec deux appartements",
  "GEBAEUDE_OHNE_WOHNNUTZUNG": "Bâtiment sans usage résidentiel",
  "GEBAUT": "Construit",
  "GEBUEHR": "Emolument",
  "GEMEINDERSCHAFT": "Indivision",
  "GEMEINDESTRASSEN": "Rue communales",
  "GEMEINSCHAFT": "Communauté",
  "GEO_LINK": "GeoLink",
  "GESAMTEIGENTUM": "Propriété commune",
  "GESAMTPFANDRECHT": "Droit de gage collectif",
  "GESAMTPFANDRECHT_KURZ": "C",
  "GESAMTTEILPFANDRECHT": "Droit de gage collectif et réparti",
  "GESAMTTEILPFANDRECHT_KURZ": "CR",
  "GESCHAEFT_BESCHREIBUNG": "Description",
  "GESCHIEDEN": "Divorcé/e",
  "GESELLSCHAFTSFORM": "Type de société",
  "GESETZLICHES_PFANDRECHT": "Hypothèque légale",
  "GEWAESSER_BISHER": "Eaux",
  "GEWAESSER_FLIESSENDES": "Eaux courantes",
  "GEWAESSER_SCHILFGUERTEL": "Roselière",
  "GEWAESSER_STEHENDES": "Eaux stagnantes",
  "GLAEUBIGER": "Créancier/ière",
  "GLAEUBIGER_ROLLE": "Créancier",
  "GLAEUBIGER_SCHULDNER": "Créancier/ière - Débiteur/débitrice",
  "GROSS_UND_EINZELHANDELSGEBAEUDE": "Bâtiments de commerce de gros et de détail",
  "GRUNDBUCH": "Registre foncier",
  "GRUNDBUCH_ABGESCHLOSSEN": "Clôturé(e) dans le registre foncier",
  "GRUNDLAST": "Charge foncière",
  "GRUNDLAST_KURZ": "CF",
  "GRUNDPFANDGLAEUBIGER": "Créancier/ière de gage immobilier",
  "GRUNDPFANDVERSCHREIBUNG": "Hypothèque",
  "GRUNDSTUECK_UNTER_ART_LIG": "Sous-espèce bien-fonds",
  "GRUNDSTUECK_UNTER_ART_SDR": "Sous-espèce DDP",
  "GUELT": "Lettre de rente",
  "GUETERGEMEINSCHAFT": "Régime de la communauté de biens",
  "GWRBAUPERIODE_8011": "Période devant 1919",
  "GWRBAUPERIODE_8012": "Période du 1919 au 1945",
  "GWRBAUPERIODE_8013": "Période du 1946 au 1960",
  "GWRBAUPERIODE_8014": "Période du 1961 au 1970",
  "GWRBAUPERIODE_8015": "Période du 1971 au 1980",
  "GWRBAUPERIODE_8016": "Période du 1981 au 1985",
  "GWRBAUPERIODE_8017": "Période du 1986 au 1990",
  "GWRBAUPERIODE_8018": "Période du 1991 au 1995",
  "GWRBAUPERIODE_8019": "Période du 1996 au 2000",
  "GWRBAUPERIODE_8020": "Période du 2001 au 2005",
  "GWRBAUPERIODE_8021": "Période du 2006 au 2010",
  "GWRBAUPERIODE_8022": "Période du 2011 au 2015",
  "GWRBAUPERIODE_8023": "Période à partir de 2016",
  "GWRBauprojekt": "Projet de construction RegBL",
  "GWRBauprojekte": "Projets de construction RegBL",
  "GWRGebaeude": "Bâtiment RegBL",
  "GWRWohnung": "Appartement RegBL",
  "GbBemerkung": "Observation",
  "Gbgeschäfte": "Affaires du registre foncier",
  "Gebaeude": "Bâtiment(s)",
  "Gebaeude-Nr.": "N° de bâtiment",
  "GebaeudeAdresse": "Adresse des bâtiments",
  "Gebaeude_Einzahl": "Bâtiment",
  "Gebaeudebezeichnung": "Désignation de bâtiment",
  "Gebaeudeflaeche": "Surface bâtiment",
  "Gebaeudeschatzung": "Estimation de bâtiment",
  "Gebaut": "Construit",
  "Geburtsdatum": "Date de naissance",
  "GeburtsdatumGruendungsdatumaktivVon": "Date de naissance / date de fondation / active depuis",
  "GeburtsdatumJahr": "Date de naissance année",
  "GeburtsdatumMonat": "Date de naissance mois",
  "GeburtsdatumTag": "Date de naissance jour",
  "Gebäude/Bauten": "Bâtiments/constructions",
  "GebäudeVersicherungsNummer": "Numéro ECA",
  "GebäudeeingangsadresseAdressen": "Localisation",
  "GefundeneBauprojekte": "Projets de construction trouvés",
  "GefundeneGebäude": "Les bâtiments trouvées",
  "GefundenePersonen": "{{rolle}} trouvé(e)s",
  "GefundeneRechte": "Les droits trouvés",
  "GeloeschteGrundstuecke": "Immeubles supprimés",
  "GemaessGrundbuch": "Selon le registre foncier",
  "Gemeinde": "Commune",
  "Gemeinde.Kuerzel": "Abréviation",
  "GemeindeAuswahl": "Sélection communes",
  "GemeindeEntfernen": "Supprimer la commune",
  "GemeindeMussVorhandenSein": "Une commune doit être saisie",
  "Gemeinden": "Commune",
  "Geogeschäfte": "Affaires du géomètre",
  "Geometergeschaeft.detail.VermarkungZurueckgestellt": "Abornement repoussé",
  "GeometergeschaeftNummer": "Numéro",
  "Geometergeschaefte": "Affaires du cadastre",
  "Geometergeschaeftszustand.BEARBEITUNG": "En traitement",
  "Geometergeschaeftszustand.BEREIT_FUER_GRUNDBUCH": "Prêt pour registre foncier",
  "Geometergeschaeftszustand.BEREIT_FUER_KORREKTURLIEFERUNG": "Prêt pour la correction",
  "Geometergeschaeftszustand.BEREIT_FUER_VERARBEITUNG": "Prêt pour le traitement",
  "Geometergeschaeftszustand.BEREIT_ZUR_VERIFIKATION": "Prêt pour vérification",
  "Geometergeschaeftszustand.EROEFFNET": "Ouvert",
  "Geometergeschaeftszustand.RECHTSGUELTIG_ABGESCHLOSSEN": "Validée et terminée",
  "Geometergeschaeftszustand.RECHTSGUELTIG_VOLLZOGEN": "Validée",
  "Geometergeschaeftszustand.RUECKMUTIERT_ABGESCHLOSSEN": "Mutation annulée",
  "Geometergeschaeftszustand.VERKNUEPFT_MIT_GRUNDBUCH": "Lié avec le registre foncier",
  "Geometergeschaeftszustand.WARTEN_AUF_VORGAENGER": "Attendre l'affaire antérieure",
  "Geometergeschaeftszustand.ZURUECK_ABGEWIESEN": "Rejeté du registre foncier",
  "Geometergeschaeftszustand.ZURUECK_ZURUECKGEZOGEN": "Retiré du registre foncier",
  "Geometergeschaeftszustand.ZURUECK_ZUR_KORREKTUR": "Retour à la correction",
  "Geometergeschäft": "Affaire du géomètre",
  "Gesamteigentum": "Propriété commune",
  "Gesamtfläche": "Surface totale",
  "Gesamtpreis": "Prix global",
  "Gesamtwert": "Valeur (CHF)",
  "Geschaeftdetails": "Détails de l'affaire",
  "GeschichteAnzeigen": "Afficher l'historique",
  "Geschlecht": "Sexe",
  "GeschlossenAm": "Immeuble clôturé le",
  "Geschäftsstatus": "Statut de l'affaire",
  "Geschäftstyp": "Type d'affaire",
  "Gesellschaftsform": "Type de société",
  "GesetzlichesPfandrecht": "Hypothèque légale",
  "GestrichenMit": "Radié(e) avec",
  "Glaeubiger": "Créancier/ière",
  "GlaeubigerGlaeubigerinVon": "Créancier de ",
  "Gläubiger": "Créancier/ière",
  "Grundbuch": "Registre foncier",
  "GrundbuchMeldungZip": "AvisRegistreFoncier.zip",
  "Grundbuchamt": "Bureau du registre foncier",
  "Grundbuchgemeinde": "Commune en lien",
  "Grundbuchgeschaeft": "Affaire du registre foncier",
  "Grundbuchgeschäft": "Affaire du registre foncier",
  "Grundbuchgeschäfte": "Affaires du registre foncier",
  "GrundbuchmeldungZuTagebuch": "Avis du registre foncier concernant l'affaire",
  "Grundbuchperson": "Personne RF",
  "Grundbuchpläne": "Plans du registre foncier",
  "Grundbuchtyp": "Tenue de registre foncier",
  "Grundgueterschaetzung": "Estimation des bien-fonds",
  "Grundlast": "Charge foncière",
  "Grundlasten": "Charge foncière",
  "Grundpfandrecht": "Droit de gage immobilier",
  "Grundpfandrechtart": "Type du droit de gage",
  "Grundpfandrechte": "Droits de gage",
  "Grundpfandrechtform": "Forme du droit de gage",
  "Grundstueck": "Immeuble",
  "GrundstueckArt": "GrundstueckArt",
  "GrundstueckKopf.Label.Gemeinde": "Commune (n° OFS)",
  "GrundstueckMitAenderungen": "Immeuble avec modifications",
  "GrundstueckMitFolgendenBodenbedeckungen": "Immeuble avec les couvertures du sol suivantes",
  "GrundstueckNummer": "N° de l'immeuble",
  "Grundstueckbeschreibung": "Description de l'immeuble",
  "Grundstuecke": "Immeuble(s)",
  "Grundstuecksart": "Type de l'immeuble",
  "Grundstück": "Immeuble",
  "GrundstückGrundstücke": "Immeuble(s)",
  "GrundstückKopie": "Copie",
  "GrundstückPerson": "Immeuble/Personne",
  "Grundstückbeschreibung": "Description de l'immeuble",
  "Grundstücke": "Immeubles",
  "Gruppe": "Groupe",
  "Gueltig": "Valide",
  "GueltigeDateiAuswaehlen": "Veuillez sélectionner un fichier valide s.v.p.",
  "Gültig": "Valide",
  "HAENGIGE": "En suspens",
  "HAUPTBUCH": "Grand livre",
  "HAUPTBUCH_ABGESCHLOSSEN": "Grand livre terminé",
  "HEIME_MIT_UNTERKUNFT_PFLEGEDIENSTE_BETREUUNG": "Foyers avec hébergement, services de soins et/ou assistance",
  "HERRENLOS": "Sans maître",
  "HOCHBAU": "Bâtiment",
  "HOEHERES_BILDUNGSWESEN_FORSCHUNG": "Enseignement supérieur et recherche",
  "HOMONYME": "Homonyme",
  "HOTELGEBAEUDE": "Bâtiment hôtelier",
  "HOTELS_RESTAURANTS": "Hôtels, restaurants",
  "HUMUSIERT_ACKER_WIESE_WEIDE": "Champ, pré, pâturage",
  "HUMUSIERT_GARTENANLAGE": "Jardin",
  "HUMUSIERT_HOCH_FLACHMOOR": "Tourbière",
  "HUMUSIERT_INTENSIVKULTUR_REBEN": "Vigne",
  "HUMUSIERT_INTENSIVKULTUR_UEBRIGE_INTENSIVKULTUR": "Autre culture intensive",
  "HUMUSIERT_UEBRIGE_HUMUSIERTE": "autre surface verte",
  "HaengigeGeschaefte": "HaengigeGeschaefte",
  "HaengigeGeschaefteAufbereiten": "Préparer affaires en suspens",
  "HaengigeGeschaefteAufträge": "Affaires/Mandats en suspens",
  "Handelsangaben": "Informations commerciales",
  "Haus-Nr.": "No de rue",
  "Header": "Header",
  "Heimatort": "Lieu d'origine",
  "Hinweis": "Indication",
  "HinweismeldungAuszuege": "Seuls 20 extraits peuvent être imprimés à la fois",
  "Historisiert": "Historisé(e)",
  "Hängig": "En cours de traitement",
  "HängigeAufträge": "Mandats en suspens",
  "HängigeGbgeschäfte": "Affaires du registre foncier en suspens",
  "HängigeGeogeschäfte": "Affaires du géomètre en suspens",
  "HängigeGeschäfte": "Affaires en suspens",
  "ID-DatumOderBelegOderRechtsgrund": "ID, Date/PJ/Titre de droit",
  "IMARBEIT": "En cours",
  "IM_BAU": "En construction",
  "INDUSTRIEGEBAEUDE": "Bâtiment industriel",
  "INEINGETRAGENERPARTNERSCHAFT": "Lié par un partenariat enregistré",
  "INHABER": "au porteur",
  "INHABER_PFANDRECHT_ART": "{{pfandrechtArt}} au porteur",
  "INHABER_PFANDRECHT_ART_PAPIER": "{{pfandrechtArt}} hypothécaire sur papier au porteur",
  "IcpPrintException": "Erreur inopinée lors de la préparation de l'extrait",
  "InEinemDokumentDrucken": "Imprimer dans un document",
  "Index": "Index",
  "Index1-2": "Index 1-2",
  "Index1-3": "Index 1-3",
  "Inhalt": "Contenu",
  "JA": "Oui",
  "JURISTISCHE_PERSON": "Personne morale",
  "Ja": "Oui",
  "JaAmDatumDurchAnmelder": "Oui. Le {{datum}} par {{anmelder}}",
  "Jahr": "Année",
  "JuristischePerson": "Personne morale",
  "KANTONAL": "cantonale",
  "KANTONSSTRASSEN": "Routes cantonales",
  "KAUFHAEUSER_GESCHAEFTSGEBAEUDE": "Grands magasins, bâtiments commerciaux",
  "KEHRICHTENTSORGUNGSANLAGEN": "Installations d'élimination des déchets",
  "KENNZEICHNUNG_GEO_GESCHAEFT": "Affaire du géomètre",
  "KIRCHEN_SAKRALBAUTEN": "Églises et édifices sacrés",
  "KIRCHEN_UND_SONSTIGE_KULTGEBAEUDE": "Églises et autres bâtiments de culte",
  "KOMMUNIKATIONSANLAGEN": "Systèmes de communication",
  "KONZESSION": "Droit de concession",
  "KRANKENHAEUSER_UND_FACHEINRICHTUNGEN_DES_GESUNDHEITSWESENS": "Hôpitaux et établissements de soins de santé spécialisés",
  "KULTURBAUTEN_MUSEEN_BIBLIOTHEKEN_DENKMAELER": "Bâtiments culturels, y compris musées, bibliothèques et monuments",
  "KantGid": "GID cantonaux",
  "KantonalePersonenID": "ID cantonale",
  "Katasternummer": "N° du cadastre",
  "Keine": "Aucun(e)",
  "KeineBerechtigungFuer": "Aucune autorisation pour {{inputField}}",
  "KeineBerechtigungFürDieseAktion": "Vous n'avez pas d'autorisation pour cette action.",
  "KeineBzwGemaessGrundbuch": "Aucune, ou mention(s) selon le registre foncier",
  "KeineDatenVorhanden": "Aucune donnée à afficher",
  "KeineResultateGefunden": "Aucun résultat.",
  "Komponenten": "Composants",
  "KuecheVorhanden": "Cuisine disponible",
  "Kuhrechte": "Etendue des droits d'alpage",
  "Kurzbeschreibung": "Description",
  "KurzdeklarationBeilage": "Déclaration sommaire en annexe",
  "LAGEFIXPUNKT": "Point fixe situation",
  "LAGERHALLEN_DEPOTS_SILOS_ZISTERNEN": "Entrepôts, dépôts, silos et citernes",
  "LANDESVERTEIDIGUNGSBAUTEN": "Structures de défense nationale",
  "LANDUMLEGUNG": "Remaniements parcellaires agricoles",
  "LANDWIRTSCHAFTLICHE_BETRIEBSGEBAEUDE": "Bâtiments d'exploitation agricole",
  "LANDWIRTSCHAFTSBAUTEN": "Bâtiments agricoles",
  "LEDIG": "Célibataire",
  "LEEREPFANDSTELLE": "Case libre",
  "LIEGENSCHAFT": "Bien-fonds",
  "LIEGENSCHAFT_ausg": "Bien-fonds",
  "LIG": "B-F",
  "LR": "Ch/D",
  "LageAufStockwerk": "Situation sur l'étage",
  "LageStockwerk": "Situation à l'étage",
  "Lagebezeichnung": "Désignation de la situation",
  "Last": "Charge",
  "LastRechtAbkürzung": "Ch/D",
  "LastetAuf": "Grevant le",
  "Ledigname": "Nom de célibataire",
  "LetzterEntgeltlicherErwerb": "DernièreAcquisitionRémunérée",
  "Liegenschaft": "Bien-fonds",
  "Link": "Lien",
  "Loading": "Les données sont chargées...",
  "Loeschbeleg": "R",
  "Login": "Login",
  "Logout": "Déconnecter",
  "Löschen": "Radier",
  "Löschgeschäft": "Affaire de radiation",
  "MAENNLICH": "Masculin",
  "MEHRFAMILIENHAEUSER": "Immeubles collectifs",
  "MEHRFAMILIENHAEUSER_REINE_WOHNGEBAEUDE_MIT_MEHREREN_WOHNUNGEN": "Maisons multifamiliales (immeubles d'habitation purs avec plusieurs appartements)",
  "MELIORATIONEN": "Méliorations",
  "MH": "MH",
  "MIT": "COP",
  "MITEIGENTUM": "Part de copropriété",
  "MITEIGENTUM_ausg": "Part de copropriété",
  "MONATLICH": "Hebdomadaire",
  "MUSEEN_BIBLIOTHEKEN": "Musées / Bibliothèques",
  "MarkiereAlsBearbeitet": "Marquer comme traité",
  "MarkiereAlsNichtBearbeitet": "Marquer comme non traité",
  "MaximalResultWarning": "Résultat incomplet, trop de données trouvées. Limitez la recherche s.v.p. Le nombre maximum d'entrées est de {{maxDisplayableRecords}}, {{recordsFound}} ont été trouvés.",
  "MaximalResultWarningKeineEinschraenkung": "Résultat incomplet, trop de données trouvées. Le nombre maximum d'entrées est de {{maxDisplayableRecords}}, {{recordsFound}} ont été trouvés.",
  "Maximalhypothek": "Hypothèque maximale",
  "Maximalzinsfuss": "Taux d'intérêt maximal",
  "MehrAnzeigen": "Montrer plus",
  "Mehrgeschossig": "À plusieurs étages",
  "Meldung": "Avis",
  "MeldungBearbeitet": "Statut de traitement de l'avis",
  "MeldungenAlsZip": "Tout exporter au format PDF (zipper)",
  "MeldungsId": "ID de l'avis",
  "Meldungsempfaenger": "Destinataires du message",
  "Mit": "avec",
  "MitAciIroleNr": "avec No ACI/IROLE",
  "MitAdresse": "avec Adresse",
  "MitGebäuden": "avec bâtiments",
  "MitGrundbuchbezug": "Avec référence au registre foncier",
  "MitSonderrechten": "Avec droits particuliers",
  "Miteigentumsanteil": "Copropriété",
  "MizenNichtErreichbar": "Erreur de connexion au centre de notifications (HTTP 401).",
  "Monat": "Mois",
  "Mutationsart": "Type de mutation",
  "NACHRUECK_RECHT": "Droit de profiter des cases libres",
  "NAMEN": "nominative",
  "NAMEN_PFANDRECHT_ART": "{{pfandrechtArt}} nominative",
  "NAMEN_PFANDRECHT_ART_PAPIER": "{{pfandrechtArt}} hypothécaire sur papier nominative",
  "NATIONALSTRASSEN": "Routes nationales",
  "NATUERLICHE_PERSON": "Personne physique",
  "NATURDENKMAL": "Monument naturel",
  "NB-Ident": "NB-Ident",
  "NEIN": "Non",
  "NEUBAU": "Bâtiment neuf",
  "NICHTBEARBEITET": "Non traité",
  "NICHT_NUTZBAR": "Inutilisable",
  "NICHT_REALISIERT": "Non réalisé",
  "NORMAL": "Normal",
  "NUTZNIESSER": "Usufruitier/ière",
  "Nachrueckungsrecht": "Droit de profiter des cases libres (pcl)",
  "Nachrückungsrecht": "Droit de profiter des cases libres",
  "Name": "Nom",
  "Name/Bezeichnung1": "Nom / désignation 1",
  "NameDerEltern": "Filiation",
  "NameEhegatte": "Nom de l'époux(se)",
  "NameOderFirma": "Nom/Entreprise",
  "Nationalitaet": "Nationalité",
  "NatuerlichePerson": "Personne physique",
  "Nein": "Non",
  "NichtBearbeitet": "Non traité",
  "NichtOeffentlicheBemerkung": "Observation non-publique",
  "NonBreakingSpace": " ",
  "NotAvailable": "s/o",
  "NotEnoughChars": "NotEnoughChars",
  "Nummer": "Numéro",
  "NurOeffentlicheAnmerkungenWerdenAngezeigt": "Seul les mentions publiques selon art. 26 al. 1 c de l'ordonnance sur le registre foncier. Autres droits selon le registre foncier.",
  "NurZentraleId": "seulement No ACI/IROLE",
  "OEFFENTLICHE_KOERPERSCHAFT": "Corporation de droit public",
  "ORTSNAME": "Nom de lieu",
  "Oberirdisch": "En surface",
  "Objekt-Nr.": "N° de l'objet",
  "Objektbezeichnung": "Désign. de l'objet",
  "Objektcode": "Code de l'objet",
  "OeffentlichRechtlicheKoerperschaft": "Collectivité de droit public",
  "Oereb": "Cadastre RDPPF",
  "Ohne": "sans",
  "Ort": "Localité",
  "Ortschaft": "Localité",
  "PARKHAEUSER": "Parking",
  "PARTERRE": "Rez-de-chaussée avec rez-de-chaussée surélevé",
  "PERSONEN_GRUPPE": "Groupe de personnes",
  "PFANDOBLIGATION": "Obligation hypothécaire",
  "PFANDRECHT": "Droit de gage",
  "PFANDRECHT_BEMERKUNG": "Droit de gage remarque",
  "PFANDRECHT_KURZ": "GI",
  "PROJEKT": "Projet",
  "PROJEKTIERT": "Projeté",
  "PROJEKT_ABGESCHLOSSEN": "Projet terminé",
  "PROJEKT_BAUBEGONNEN": "Projet en chantier",
  "PROJEKT_NICHT_REALISIERT": "Projet non réalisé",
  "PROJEKT_SISTIERT": "Projet reporté",
  "PROJEKT_ZURUECKGEZOGEN": "Projet retiré",
  "PROVISORISCH": "Provisoire",
  "PROVISORISCHE_UNTERKUNFT": "Hébergement provisoire",
  "PROVISORISCH_ABGEWIESEN": "Rejetée de manière provisoire",
  "Perimeter": "Périmètre",
  "Personalien": "Coordonnées",
  "Personart": "Type de personne",
  "Personengruppe": "Groupe",
  "Personenregister": "Registre des personnes",
  "PersonstammVollstaendig": "Complète",
  "PfandrechtDetail": "Droit de gage détail",
  "PfandrechtGläubiger": "Droit de gage créancier/ière",
  "PfandrechtIdsAufbereiten": "Préparer ID des droits de gage",
  "Pfandrechtbelastungen": "Droit de gage charges",
  "Pfandrechtgläubiger": "Droit de gage créancier",
  "Pfandrechtschuldner": "Droit de gage débiteur",
  "Pfandstelle": "Case hypothécaire",
  "Pfandsumme": "Somme garantie par gage",
  "Pfandtitel": "Titre de gage",
  "Plan": "Plan",
  "PlanZuGrundstueckAnzeigen": "Afficher plan pour immeuble {{param}}",
  "PlzOderOrtschaft": "NPA, Localité",
  "PlzOrt": "NPA/lieu",
  "Preis": "Prix",
  "ProjektAbgeschlossen": "Projet terminé",
  "ProjektBaubegonnen": "Projet en chantier",
  "ProjektNichtRealisiert": "Projet non réalisé",
  "ProjektSistiert": "Projet reporté",
  "ProjektZurueckgezogen": "Projet retiré",
  "Projektiert": "Projeté",
  "ProjektiertStatus": "Statut projeté",
  "ProjektierteGebaeudeWohnungen": "Bâtiments / Logements projetés",
  "Projektmutation": "(Mutation de projet)",
  "Projektstatus": "Statut du projet",
  "Projektumschreibung": "Description du projet",
  "Protokollnummer": "Année de révision",
  "Publikationsdatum": "Date de publication",
  "QUALITAET_FLAECHE": "Qualité de la superficie",
  "QUELLENRECHT": "Droit de source",
  "QualitaetAV": "Standard Qualité MO",
  "QualitaetAV.AV93": "MO93",
  "QualitaetAV.GRAFISCH": "graphique",
  "QualitaetAV.PN": "NP",
  "QualitaetAV.PN_DEFINITIV": "NP_reconnue_def",
  "QualitaetAV.PN_PROVISORISCH": "NP_reconnue_prov",
  "QualitaetAV.UNVERMESSEN": "sans mensuration",
  "REBEN_BISHER": "Vigne",
  "RECHNUNGSADRESSE": "Adresse pour facture",
  "RECHTSDOMIZIL": "Domicile en droit",
  "RECHTSFORM": "Forme juridique",
  "RECHTSGRUND": "Titre de droit",
  "RECHTSGUELTIG": "Valide",
  "RECHTSGUELTIG_ABGESCHLOSSEN": "Validée et terminée",
  "RECHTSGUELTIG_AUSGETRAGEN": "Validée et déchargée",
  "RECHTSGUELTIG_VOLLZOGEN": "Validée",
  "REFERENZADRESSE": "Adresse de référence",
  "REGISTERSCHULDBRIEF": "Cédule de registre",
  "REKURS": "Recours",
  "REKURS_AKZEPTIERT": "Recours accepté",
  "RESTAURANTS_UND_BARS_IN_GEBAEUDEN_OHNE_WOHNNUTZUNG": "Restaurants et bars dans des bâtiments sans usage résidentiel",
  "RF": "RF",
  "RUECKMUTIERT_ABGESCHLOSSEN": "Mutation annulée",
  "RUNDUNGSDIFFERENZ": "Différence d’arrondi",
  "Recht": "Droit",
  "Rechtart": "Type de droit",
  "RechteId": "ID pour les droits",
  "Rechtsform": "Forme juridique",
  "Rechtsgrund": "Titre de droit",
  "RechtsgrundArt": "Type",
  "Rechtsgültig": "Validé(e)",
  "Region": "Région",
  "RegistraturText": "Enregistrement",
  "Renovationsjahr": "Année de rénovation",
  "Rolle": "Rôle",
  "RolleGläubiger": "Rôle créancier/ière",
  "Rubrik": "Rubrique",
  "Rubriken": "Rubriques",
  "RueckmeldungGrundbuch": "Date du message de réponse RF",
  "SCHIFFSVERKEHRSANLAGEN": "Installation de trafic maritime",
  "SCHULDBRIEF": "Cédule",
  "SCHULDNER": "Débiteur/débitrice",
  "SCHULDNER_ROLLE": "Débiteur",
  "SCHULEN_BILDUNGSWESEN_BIS_MATURASTUFE": "Écoles, système éducatif (jusqu'au niveau de la maturité)",
  "SCHUL_UND_HOCHSCHULGEBAEUDE_FORSCHUNGSEINRICHTUNGEN": "Bâtiments scolaires et universitaires, installations de recherche",
  "SCHWEIZERISCHE_JURISTISCHE_PERSON": "Personne morale suisse",
  "SDR": "DDP",
  "SDR_DIENSTBARKEIT": "Servitude DDP",
  "SDR_DIENSTBARKEIT_KURZ": "SE (DDP)",
  "SDR_ausg": "Droit distinct et permanent",
  "SEYBUCH": "Droits d'alpage",
  "SONDERBAU": "Construction spéciale",
  "SONSTIGE_HOCHBAUTEN": "Autres bâtiments non spécifiés ailleurs",
  "SPORTHALLEN": "Salles de sport",
  "SPORTHALLEN_SPORTPLAETZE": "Salles et terrains de sport",
  "SPRACHE": "Langue",
  "STANDARD": "Standard",
  "STOCK": "Etage",
  "STOCKWERK": "Propriété par étages",
  "STOCKWERK_ausg": "Propriété par étages",
  "STORNIERT": "Annulé(e)",
  "STR": "PR",
  "STRASSE": "Rue",
  "STRASSE_WEG_TROTTOIR_RAV": "Route, chemin, trottoir, îlot",
  "STREITIGE_GRENZE": "Limite litigieuse",
  "STR_lang": "Parcelle de rue",
  "STW": "PPE",
  "SUSPENDIERT": "Suspendue",
  "Schliessen": "Clôturer",
  "SchnellSuche": "Recherche rapide",
  "Schuldner": "Débiteur/débitrice",
  "SchuldnerSchuldnerinVon": "Débiteur de ",
  "SchulduebernahmeTotal": "Reprise de dette",
  "SelbststaendigUndDauerndeRechte": "Droits distincts et permanents",
  "SelbststaendigesUndDauerndesRechtMitAbkuerzung": "Droit distinct et permanent (DDP)",
  "SelbstständigesUndDauerndesRecht": "Droit distinct et permanent",
  "Select date": "Sélectionnez une date",
  "Servitute": "Servitude",
  "ServitutenregisterNr": "N° registre des servitudes",
  "Sitz": "Siège",
  "SonderpreisZugabe": "Prix spécial pour accessoires",
  "SonderpreisZugaben": "Prix spécial pour accessoires",
  "Sonderrecht": "Droit exclusif",
  "Sonderrechte": "Droit exclusif",
  "Speichern": "Enregistrer",
  "Sprache": "Langue",
  "Stammgrundstueck": "Immeuble de base",
  "Stammperson": "Personne",
  "StammpersonImGrundbuch": "Personne de base dans le registre foncier",
  "StandardSuche": "Recherche standard",
  "Standardrechtbelastungen": "Droit standard charges",
  "StandardrechteIdsAufbereiten_DI_GL_SDR_VO_AN": "Préparer IDs de droits standard (S, ChF, DDP, Ann, Men)",
  "Standardsuche": " Recherche standard",
  "Startdatum": "Date du démarrage",
  "Status": "Statut",
  "StehtAufFolgendenGrundstuecken": "Le bâtiment est sur les immeubles suivantes",
  "Steuerjahr": "Année fiscale",
  "Stichwort": "Mot clé",
  "StichwortOderAblaufdatum": "Date d'échéance/mot clé",
  "Stichwortzusatz": "Adjonction",
  "Stockwerk": "Etage",
  "Stockwerkeigentum": "Propriété par étages",
  "Strasse": "Rue",
  "StrasseBenanntesGebiet": "Rue / Lieu dénommé",
  "StrasseHausNr": "Rue / n°",
  "StrasseOderFlurnameHausnummer": "Rue, numéro",
  "StrasseOderHausnummer": "Rue, numéro",
  "Suche": "Recherche",
  "Suchergebnis": "Résultat de la recherche",
  "TAGEBUCH": "journal",
  "TAGEBUCH_ABGESCHLOSSEN": "Journal terminé",
  "TEILPFANDRECHT": "Droit de gage réparti",
  "TEILPFANDRECHT_KURZ": "R",
  "TIEFBAU": "Génie civil",
  "TOPOMAPS": "Topomaps",
  "Tag": "Jour",
  "Tagebuchnummer": "Numéro de journal",
  "Tagebuchstatus": "Etat journal",
  "Teilbetrag": "Montant partiel",
  "TeilbetragGruppe": "Montant réparti groupe",
  "Teilflaeche": "Surface partielle",
  "Template": "Template",
  "TiteleingangGrundbuch": "Entrée du titre au registre foncier",
  "Today": "Aujourd'hui",
  "TodesdatumLiquidationsdatuminaktivSeit": "Date de décès / date de liquidation / inactive depuis",
  "Totalflaeche": "Surface totale",
  "Typ": "Type",
  "TypDerBauwerke": "Type des bâtiments",
  "UEBRIGEART_lang": "Autres",
  "UEBRIGER_STRASSENBAU_PARKPLAETZE": "Autres travaux routiers, places de stationnement",
  "UEBRIGES_RECHT": "Autre droits",
  "UEBRIGES_SPEZIALISIERTES_GESUNDHEITSWESEN": "Autres établissements de santé spécialisés",
  "UEBRIGE_BAUTEN_IM_ZUSAMMENHANG_MIT_WOHNGEBAEUDEN": "Autres constructions en rapport avec l'habitation",
  "UEBRIGE_BERECHTIGTE": "Autres bénéficiaires",
  "UEBRIGE_ENTSORGUNGSANLAGEN": "Installations de traitement des autres déchets",
  "UEBRIGE_INFRASTRUKTUR": "Autres infrastructures",
  "UEBRIGE_VERKEHRSANLAGEN": "Autres constructions vouées aux transports",
  "UEBRIGE_VERSORGUNGSANLAGEN": "Autres installations d'approvisionnement",
  "UEBRIGE_VERWENDUNG_FUER_WIRTSCHAFTLICHE_ZWECKE": "Autres constructions destinées à des activités économiques",
  "UFERVERBAUUNGEN_STAUDAEMME": "Aménagements de berges et barrages",
  "UID": "IDE",
  "UID_STATUS": "Statut de l'IDE",
  "UMBAU": "Transformation",
  "UNB": "INC",
  "UNBEKANNT": "Inconnu",
  "UNBEKANNT_ausg": "Inconnu",
  "UNBESTIMMT": "Indéfini",
  "UNKULTIVIERTES_GEBIET_BISHER": "Région inculte",
  "UNTERGESCHOSS": "Sous-sol",
  "UNVERHEIRATET": "non marié",
  "UebernahmeGrundstueckgewinnsteuer": "Prise en charge de l'impôt sur les gains immobiliers par l'acquéreur",
  "UebrigeBerechtigte": "Autres bénéficiaires",
  "UebrigeBerechtigungen": "Autres bénéficiaires",
  "UidBeiNatuerlichenPersonenDrucken": "IDE pour les personnes physiques",
  "UidStatus": "Statut de l'IDE",
  "Unterart": "Sous-type",
  "Unterirdisch": "Souterrain",
  "Url": "Url",
  "User menu": "User menu",
  "VEC": "VEC",
  "VEC_lang": "Chemin de fer",
  "VEGETATIONSLOS_ABBAU_DEPONIE": "Gravière, décharge",
  "VEGETATIONSLOS_FELS": "Rocher",
  "VEGETATIONSLOS_GEROELL_SAND": "Éboulis, sable",
  "VEGETATIONSLOS_GLETSCHER_FIRN": "Glacier, névé",
  "VEGETATIONSLOS_UEBRIGE_VEGETATIONSLOSE": "Autre surface sans végétation",
  "VERAEUSSERER": "aliénateur",
  "VERHEIRATET": "Marié",
  "VERIFIKATION": "Vérification",
  "VERKNUEPFT_MIT_GRUNDBUCH": "Liée avec le registre foncier",
  "VERTRAGSART": "Forme de contrat",
  "VERWALTERADRESSE": "Adresse administration",
  "VERWITWET": "Veuf",
  "VIC": "VIC",
  "VIC_lang": "Chemin vicinal",
  "VORBEHALTENERVORGANG": "Réserve de rang",
  "VORMERKUNG": "Annotation",
  "VORMERKUNG_KURZ": "AN",
  "VORPRUEFUNG": "Examen",
  "ValidierungsFehler": "Erreur lors de la validation : {{fehlerMeldung}}",
  "Veraeusserer": "Vendeur",
  "Verarbeitungsart": "Type de traitement",
  "Verarbeitungsstatus": "Statut de traitement",
  "VerbindungZumServerNichtMöglich": "La connexion à Internet est interrompue. Essayez d'actualiser avec F5 ou vérifiez votre connexion Internet.",
  "VergleichMitZpvPerson": "Comparaison avec personne GCP",
  "VersicherungsNr": "Numéro d'assurance",
  "VersicherungsNummerAbkürzung": "No ECA",
  "Versicherungsnummer": "N° d'assurance",
  "Vertragsart": "Nature du contrat",
  "Vertragstexte": "Textes du contrat",
  "VertragstexteAufbereiten": "Préparer textes de contrat",
  "VonAenderungenBetroffeneRubriken": "Rubriques concernées par les modifications",
  "VoraussichtlicheBaudauer": "Durée prévisionnelle des travaux",
  "Vormerkung": "Annotation",
  "Vormerkungen": "Annotations",
  "Vorname": "Prénom",
  "Vorname/Bezeichnung2": "Prénom / désignation 2",
  "WALD_BISHER": "Forêt",
  "WARTEN_AUF_VORGAENGER": "En attente des affaires précédentes",
  "WASSERENTSORGUNGSANLAGEN": "Installations d'évacuation et de traitement des eaux usées",
  "WASSERVERSORGUNGSANLAGEN": "Installations pour l'alimentation en eau",
  "WEIBLICH": "Féminin",
  "WEIDEN_BISHER": "Pâturage",
  "WEIDWALD_BISHER": "Pâturage boisé",
  "WERKSTAETTEN_FABRIKGEBAEUDE": "Fabriques, usines, ateliers",
  "WOECHENTLICH": "Mensuel",
  "WOHNADRESSE": "Adresse du domicile",
  "WOHNGEBAEUDE_FUER_GEMEINSCHAFTEN": "Habitats communautaires",
  "WOHNGEBAEUDE_MIT_NEBENNUTZUNG_BAUERNHAEUSER": "Bâtiments à usage annexe (y compris ruraux)",
  "WOHNHEIME_OHNE_PFLEGEDIENSTE_BETREUUNG": "Foyers sans soins médicaux et/ou services d'assistance sociale",
  "WYTWEIDE_UEBRIGE_BESTOCKTE": "Pâturage boisé / autre boisée",
  "Weiter": "suivant",
  "WeitereBauprojektdaten": "Autres données du projet de construction",
  "WeitereRechtsgründeAufbereiten": "Préparer d'autres titres de droit",
  "WeitereVornamen": "Autres prénoms",
  "WenigerAnzeigen": "Montrer moins",
  "Wertquote": "Valeur de quote-part",
  "Wohnungen": "Logements",
  "Wohnungsflaeche": "Surface du logement",
  "Wohnungsnummer": "Numéro du logement",
  "Wohnungsstatus": "Statut",
  "XML": "XML",
  "XML_HTML": "XML-HTML",
  "ZPV-person": "Personne GCP",
  "ZPVNummer": "Numéro GCP",
  "ZURUECKGEZOGEN": "Retirée",
  "ZURUECKGEZOGEN_AUSGETRAGEN": "Retirée et déchargée",
  "ZURUECK_ABGEWIESEN": "Rejeté du registre foncier",
  "ZURUECK_ZURUECKGEZOGEN": "Retiré du registre foncier",
  "ZURUECK_ZUR_KORREKTUR": "Retour pour correction",
  "ZUSTELLADRESSE": "Adresse destinataire",
  "Zeilen": "Lignes",
  "ZeitraumBis": "Au",
  "ZeitraumVon": "Du",
  "ZinsUndAbzahlungsbestimmungen": "Conditions spéciales de taux d'intérêt et d'amortissement",
  "Zivilstand": "État civil",
  "ZuExportierendeGrundstuecke": "Immeubles à exporter",
  "ZuGunsten": "en faveur de",
  "ZuGunstenLasten": "Ch/D",
  "ZuLasten": "à la charge de",
  "ZuVieleRequests": "Vous avez fait trop de demandes. Veuillez réessayer dans une minute.",
  "ZuVieleRequestsHeute": "Vous avez atteint le nombre de requêtes autorisées pour aujourd'hui. Réessayez demain",
  "Zuklappen": "fermer",
  "Zurück": "Retour",
  "ZurückZumInhalt": "Retour au contenu",
  "Zurücksetzen": "Réinitialiser",
  "Zusatzangaben": "Informations supplémentaires",
  "Zustand": "Etat de l'inscription",
  "actionbar.reset": "Réinitialiser",
  "actionbar.search": "Rechercher",
  "aktenempfaenger": "Destinataire",
  "aktualisierungsdatum": "Date de mise à jour",
  "alte-grunbbuchmeldungen.datenbestandBisUndMit": "Avis concernant la période prenant fin au 30 septembre 2009",
  "alte-grundbuchmeldung.ListTitel": "Anciens avis retrouvés",
  "alte-grundbuchmeldung.SucheTitel": "Recherche des anciens avis du registre foncier",
  "altegrundbuchmeldung.search.breadcrumb": "Anciens avis du registre foncier",
  "amtlicheBewertung": "Evaluation officielle",
  "an": "à ",
  "anonymous": "anonymous",
  "anschrift": "Adresse",
  "atLeast2Letters": "Au moins deux caractères sont requis.",
  "auf": "sur",
  "auftrag.ListTitel": "Des ordre trouvées",
  "auftraggeber": "Mandant",
  "auftragsTyp": "auftragsTyp",
  "auszugAmtlicheBewertungComponent": "Évaluation officielle",
  "auszugAnmerkungenComponent": "Mentions",
  "auszugDienstbarkeitenComponent": "Servitudes",
  "auszugDienstbarkeitenPlaceHolderComponent": "Servitudes",
  "auszugDominierteGrundstueckeComponent": "Immeubles dominés",
  "auszugEigentumComponent": "Propriété",
  "auszugGemeindeGrundstueckComponent": "Informations relatives à la commune",
  "auszugGrundbuchUebersichtComponent": "Aperçu du registre foncier",
  "auszugGrundbuchUebersichtMiteigentumComponent": "Aperçu du registre foncier copropriété",
  "auszugGrundbuchUebersichtStockwerkComponent": "Aperçu du registre foncier propriété par étages",
  "auszugGrundbuchVertragstexteComponent": "Textes du contrat",
  "auszugGrundlastenComponent": "Charges foncières",
  "auszugGrundstueckBeschreibungLiegenschaftComponent": "Desciption de l'immeuble",
  "auszugGrundstueckBeschreibungMiteigentumComponent": "Desciption de l'immeuble",
  "auszugGrundstueckBeschreibungSDRComponent": "Desciption de l'immeuble",
  "auszugGrundstueckBeschreibungStockwerkComponent": "Desciption de l'immeuble",
  "auszugGwrComponent": "auszugGwrComponent",
  "auszugHaengigeGeschaefteGrundbuchComponent": "Affaires en suspens",
  "auszugOerebComponent": "Cadastre RDPPF",
  "auszugOerebPlaceHolderComponent": "Cadastre RDPPF",
  "auszugPfandrechteComponent": "Droit de gage",
  "auszugRangregelungenComponent": "Rapport de rang",
  "auszugSeybuchAlpgrundstueckeComponent": "Données du registre foncier alp",
  "auszugSeybuchGrundbuchDaten": "Données du registre foncier alp",
  "auszugSeybuchGrundstueckBeschreibung": "Desciption de l'immeuble",
  "auszugVermessungUebersichtLiegenschaftComponent": "Rapport du mensuration bien-fonds",
  "auszugVermessungUebersichtSDRComponent": "Rapport du mensuration DDP",
  "auszugVormerkungenComponent": "Annotations",
  "avMutationsNummer": "Numéro de la mutation",
  "backToIntercapi": "Retour à {{name}}",
  "batch.auftrag.delete.message": "l'ordre",
  "batchauftrag.detail.Titel": "Ordre de traitement par lots : ",
  "bearbeitetstatusHeading": "Statut de traitement",
  "belegeZu": "PJ pour ",
  "berechtigtePersonen": "des personnes bénéficiaires",
  "bfsNummer": "N° OFS",
  "bis": "jusqu'au",
  "breadcrumbauskunftgrundbuchmeldung": "Avis du registre foncier",
  "breadcrumbauskunftgrundbuchmeldunglist": "Résultat de la recherche",
  "cantSearchAlone": "Ce champ ne peut pas être recherché seul",
  "cmisModal.fensterSchliessen": "Clôturer fenêtre",
  "component.tablewrapper.nichtVollstaendigGeladen": "Attention, toutes les données ne sont pas chargées.",
  "component.tablewrapper.resume": "Télécharger",
  "component.tablewrapper.suspend": "Pause",
  "configuration.actions": "Actions",
  "configuration.cancel": "Annuler",
  "configuration.deutscherLink": "URL DE",
  "configuration.deutscherName": "Nom DE",
  "configuration.download": "Télécharger",
  "configuration.dropZone": "Drop zone",
  "configuration.fileAuswaehlen": "Choisir un fichier",
  "configuration.franzoesischerLink": "URL FR",
  "configuration.franzoesischerName": "Nom FR",
  "configuration.konfigurationDerAnsicht": "Configuration de la présentation",
  "configuration.konfigurationHeraufladen": "Envoyer la configuration",
  "configuration.konfigurationHerunterladen": "Télécharger la configuration",
  "configuration.konfigurationVerwalten": "Gérer la configuration",
  "configuration.linksImMenuUnterstuetzung": "Liens dans le menu Information",
  "configuration.linksImMenuUnterstuetzungPublic": "Liens dans le menu information (Intercapi-Public)",
  "configuration.name": "Name",
  "configuration.position": "Position",
  "configuration.progress": "Progrès",
  "configuration.queueLength": "Nombre",
  "configuration.reihenfolgeGrundstueckdetail": "Ordre détail des immeubles",
  "configuration.reihenfolgePfandrechtdetail": "Ordre détail des droits de gage",
  "configuration.reihenfolgeStandardrechtdetail": "Ordre détail des droits standard",
  "configuration.remove": "Supprimer",
  "configuration.size": "Taille du fichier",
  "configuration.status": "Statut",
  "configuration.titel": "Nom",
  "configuration.upload": "Envoyer",
  "configuration.uploadQueue": "File d’attente de téléchargement",
  "core.navigation.abmelden": "Déconnecter",
  "core.navigation.altegrundbuchmeldung": "Anciens avis du registre foncier",
  "core.navigation.amtlicheBewertung": "Evaluation officielle",
  "core.navigation.berechtigtePersonen": "Personnes bénéficiaires",
  "core.navigation.ech0134.empfaenger": "Destinataire de l'avis eCH",
  "core.navigation.ech0134.grundbuchmeldungen": "Avis du registre foncier eCH",
  "core.navigation.erweitertesSuchregister": "Liste des propriétaires BE",
  "core.navigation.gebaeude": "Bâtiment",
  "core.navigation.gebaeudeUndWohnungsregister": "Registre des bâtiments et logements",
  "core.navigation.gemeindeGemeindekreis": "Commune/arrondissement",
  "core.navigation.geometergeschaeft": "Affaires du/de la géomètre",
  "core.navigation.glossar": "Glossaire",
  "core.navigation.grundbuch": "Registre foncier",
  "core.navigation.grundbuchgeschaeft": "Affaires du registre foncier",
  "core.navigation.grundbuchmeldung": "Avis du registre foncier",
  "core.navigation.grundstueck": "Immeubles",
  "core.navigation.gwrBauprojekte": "Projets de construction RegBL",
  "core.navigation.gwrGebaeude": "Bâtiment RegBL",
  "core.navigation.home": "Page d’accueil",
  "core.navigation.importExport": "Import / Export",
  "core.navigation.impressumRechtliches": "Mentions légales et informations juridiques",
  "core.navigation.konfiguration": "Configuration",
  "core.navigation.meineGrundstueckePublic": "Mes immeubles",
  "core.navigation.meineGrundstueckePublic.identifizierungsStufeUnzureichend": "Vous ne disposez pas des droits nécessaires pour consulter ces données. ",
  "core.navigation.meineGrundstueckePublic.stepUpRegistrierung": "Veuillez vous enregistrer à l’adresse suivante",
  "core.navigation.meineGrundstueckePublic.stepUpRegistrierungLinkText": "Upgrade niveau d'identification",
  "core.navigation.neskoab": "NESKOAB",
  "core.navigation.publikation": "Publications",
  "core.navigation.rechte": "Droits",
  "core.navigation.stammdaten": "Données de base",
  "core.navigation.stammpersonen": "Personnes",
  "core.navigation.system": "Système",
  "core.navigation.unterstuetzung": "Information",
  "core.navigation.unterstuetzungPublic": "Information",
  "core.navigation.vermessung": "Mensuration",
  "dashboard.rechtehinweis.legalHintComment": "Seuls les extraits délivrés et légalisés par le bureau compétent ou l'autorité compétente ont force obligatoire.",
  "dashboard.rechtehinweis.legalHintComment1": " . ",
  "dashboard.rechtehinweis.legalHintHeader": "Remarque: validité des données",
  "dashboard.rechtehinweis.legalHintMessage": "Les données et les renvois contenus sont fournis sans garantie et n'ont aucun effet juridique.",
  "datenexport.BODENBEDECKUNGSFILTER": "Exportation d'immeubles standard - Filtre de couverture du sol",
  "datenexport.EIGENTUEMERART": "Exportation d'immeubles standard - Type de propriétaire",
  "datenexport.EIGENTUEMERLISTE": "Exportation d'immeubles standard - Liste de propriétaires",
  "datenexport.EIGENTUEMERREGISTER": "Exportation d'immeubles standard - Registre des propriétaires",
  "datenexport.GEAENDERTEBODENBEDGS": "Exportation d'immeubles standard - Immeubles modifiés avec restriction sur la nature",
  "datenexport.GEAENDERTEGS": "Exportation d'immeubles standard - Immeubles modifiés",
  "datenexport.GEBAEUDELISTE": "Exportation d'immeubles standard - Liste de bâtiments",
  "datenexport.GELAN": "GELAN",
  "datenexport.GELOESCHTBODENBEDGS": "Exportation d'immeubles standard - Immeubles supprimés avec restriction sur la nature",
  "datenexport.GELOESCHTEGS": "Exportation d'immeubles standard - Immeubles supprimés",
  "datenexport.GRUNDSTUECKLISTE": "Exportation d'immeubles standard - Liste d'immeubles",
  "datenexport.RECHTEREGISTER": "Registre des droits",
  "datenexport.STANDARD": "Exportation d'immeubles standard",
  "datenexport.auftrag": "Ordre",
  "datenexport.auftragstitelUndBeschreibung": "Titre et description de l' ordre",
  "datenexport.ausfuehrungsdatum": "Date d'exécution",
  "datenexport.auswahlAuftragsexportTemplate": "Sélection template pour le type de l'exportation",
  "datenexport.auswahlAuftragsoptionen": "Sélection des critères de l'ordre",
  "datenexport.auswahlAuftragsoptionen_readonly": "Options de commande sélectionnées",
  "datenexport.auswahlAuftragstyp": "Sélection du type de l'exportation",
  "datenexport.auswahlAuftragstyp_readonly": "Type de commande sélectionné",
  "datenexport.auswahlBetroffenerDatenbestand": "Sélection de la base de données affectée",
  "datenexport.auswahlBetroffenerDatenbestand_readonly": "Base de données sélectionnée",
  "datenexport.auswahlErgebnisoptionen": "Sélection des critères de résultat",
  "datenexport.auswahlErgebnisoptionen_readonly": "Options de résultats sélectionnées",
  "datenexport.beschreibung": "Description",
  "datenexport.detailsZumAuftraggeber": "Détails sur le client",
  "datenexport.email1": "Émail 1",
  "datenexport.email2": "Émail 2",
  "datenexport.email3": "Émail 3",
  "datenexport.format": "Format",
  "datenexport.informationAnFolgendeEmpfaenger": "Informations aux destinataires suivants (max. 3)",
  "datenexport.periodizitaet": "Périodicité",
  "datenexport.periodizitaetValues": "datenexport.periodizitaetValues",
  "datenexport.prioritaet": "Priorité",
  "datenexport.prioritaetValues": "datenexport.prioritaetValues",
  "datenexport.stapelverarbeitungsauftragErstellen": "Créer on lot",
  "datenexport.titel": "Titre",
  "delete.check.modal.body": "Voulez-vous vraiment radier '{{entity}}' ?",
  "delete.check.modal.title": "Radier",
  "detailGrundstueckAnmerkungen": "Mentions",
  "detailGrundstueckBeschreibung": "Description",
  "detailGrundstueckDienstbarkeiten": "Servitudes",
  "detailGrundstueckEigentum": "Propriété",
  "detailGrundstueckGeschaefteAuftraege": "Affaires/Mandats",
  "detailGrundstueckGrundlasten": "Charges foncières",
  "detailGrundstueckGrundpfandrechte": "Droit de gage",
  "detailGrundstueckRangregelungen": "Rapport de rang",
  "detailGrundstueckVormerkungen": "Annotations",
  "detailPfandrechtBelastungen": "Charges",
  "detailPfandrechtGlaeubiger": "Créancier/ière",
  "detailPfandrechtHaengigeGeschaefte": "Affaires en suspens",
  "detailPfandrechtKopfdaten": "Données en-tête",
  "detailPfandrechtPerimeter": "Périmètre",
  "detailPfandrechtPfandtitel": "Titre de gage",
  "detailPfandrechtSchuldner": "Débiteur/débitrice",
  "detailStandardrechtBelastungen": "Charges",
  "detailStandardrechtHaengigeGeschaefte": "Affaires en suspens",
  "detailStandardrechtKopfdaten": "Données en-tête",
  "detailStandardrechtPerimeter": "Périmètre",
  "detailsGemeindeGb": "Détails de la commune {{name}}",
  "detailsGeometerGeschäft": "Détails de l'affaire du cadastre",
  "detailsGeschäft": "Détails de l'affaire",
  "detailsGrundstueck": "Détails de l'immeuble {{nummer}}",
  "detailsMutationAnzeigen": "Détails de mutation MO",
  "dirty.check.modal.body": "Vous êtes sûr de vouloir quitter le site ?",
  "dirty.check.modal.title": "Données non sauvegardées",
  "dokulinkModal.fensterSchliessen": "Clôturer fenêtre",
  "durch": "par",
  "eBelege": "PJ éléctronique",
  "ech0134.grundbuchmeldung.list": "Avis du registre foncier eCH trouvés",
  "ech0134.grundbuchmeldungen.datumVersandBis": "Date d'expédition jusqu'au",
  "ech0134.grundbuchmeldungen.datumVersandVon": "Date d'expédition du",
  "ech0134.grundbuchmeldungen.delete": "Annuler les avis du registre foncier eCH",
  "ech0134.grundbuchmeldungen.empfaenger": "Destinataire de l'avis eCH",
  "ech0134.grundbuchmeldungen.reset.message": "Avis eCH registre foncier {{geschaeftsnummer}} au destinataire {{sedexId}}",
  "ech0134.grundbuchmeldungen.status": "Statut de l'avis",
  "ech0134.grundbuchmeldungen.suche": "Recherche d'avis RF eCH",
  "ech0134.grundbuchmeldungen.title": "Avis du registre foncier eCH",
  "egbpid.gehoertZuStammperson": "L'EGBPID entré correspond à la personne de base suivante :",
  "egbpid.navigationTitel": "Afficher personne de base ?",
  "egbpid.stammpersonAnzeigen": "Voulez-vous afficher la personne de base ?",
  "eigentuemerAdressliste.egridList": "Liste d'E-GRID",
  "eigentuemerAdressliste.eigentuemerAdressliste": "Liste d'adresses des propriétaires",
  "eigentuemerAdressliste.infoEigentuemerAdressliste": "Une liste d'adresses de propriétaires est générée à partir de la liste de numéros E-GRID",
  "eigentuemerAdressliste.infoKommaTrennung": "La liste des numéros E-GRID doit être séparée par des virgules",
  "eigentuemerAdressliste.infoMizen": "La liste d'adresses des propriétaires sera disponible dans Mizen",
  "eigentuemerAdressliste.listeErstellen": "Créer une liste",
  "eigentuemerAdressliste.mizen": "Une liste d'adresses de propriétaires sera créée. La liste sera envoyée à Mizen.",
  "eigentumImGrundbuch": "Propriété au registre foncier",
  "eigentumanteil.anteilUnbekannt": "quote-part inconnue",
  "eigentumanteil.unbekannt": "Inconnu",
  "eintragungAmtlicheBewertung": "Inscriptions de l'évaluation officielle",
  "elasticsearch.options": "Options de recherche",
  "email": "E-Mail",
  "erweitern": "élargir",
  "erweitertesSuchregister.MitGebaeude": "Avec des bâtiments",
  "erweitertesSuchregister.infoMessage": "Crée, une liste de propriétés dont le canton de Berne est enregistré comme propriétaire. La création peut prendre plusieurs minutes.",
  "externeGemeinde": "Commune externe",
  "false": "Non",
  "forbidden.text": "Vous n'êtes pas autorisé à prendre les mesures suivantes.",
  "forbidden.title": "Accès refusé",
  "functionbar.back": "Retour",
  "functionbar.cancel": "Annuler",
  "functionbar.continue": "Continuer",
  "functionbar.delete": "Radier",
  "functionbar.edit": "Éditer",
  "functionbar.new": "Nouveau",
  "functionbar.save": "Enregistrer",
  "gebaeude.BE-GID": "BE-GID",
  "gebaeude.BreadcrumbSuche": "Registre des bâtiments",
  "gebaeude.Egid": "EGID",
  "gebaeude.EgidKantGid": "EGID / GID cant.",
  "gebaeude.KantonalerGid": "GID cantonaux",
  "gebaeude.SucheTitel": "Recherche par bâtiments",
  "gebaeude.gehoertZuSDR": "appartient à DDP",
  "gebaeudeart": "Type de bâtiment",
  "gebauede.gehoertZuSDR": "gebauede.gehoertZuSDR",
  "geburtsdatumInZukunft": "La date de naissance est dans le futur.",
  "gebäudeeingangHeading": "Entrée du bâtiment",
  "gefundeneGemeinden": "Les communes trouvées",
  "gefundeneGeometergeschaefte": "Affaires du géomètre trouvées",
  "gefundeneGrundbuchgeschaefte": "Les affaires du registre foncier trouvées",
  "gegeneintraegeDITDienstbarkeitenDrucken": "Imprimer les contre-inscriptions des servitudes (DI/T)",
  "gehoertZu": "Fait partie de:",
  "gehoertZuFolgenderPolitischerGemeinde": "Appartient à la communauté politique",
  "gehoertZuGrundstueck": "Appartient à l'immeuble suivant",
  "gemaessAmtlicherBewertung": "Selon l'évaluation officielle",
  "gemaessGrundbuch": "selon registre foncier",
  "gemaessZPV": "Selon le registre GCP",
  "gemeinde.SucheTitel": "Recherche par communes",
  "gemeinde.bfs": "Numéro OFS",
  "gemeinde.breadcumbSuche": "Commune / arrondissement",
  "gemeinde.kreis": "Numéro d'arrondissement",
  "gemeinde.name": "Nom",
  "geometrischAuf": "Géométriquement sur",
  "glaeubiger": "Créancier/ière",
  "grundbuchmeldung.SucheTitel": "Recherche d'avis du registre foncier",
  "grundbuchmeldung.datummeldung": "Date d'expédition",
  "grundbuchmeldung.download": "Télécharger les avis",
  "grundbuchmeldung.empfaenger.bezeichnung": "Désignation du destinataire",
  "grundbuchmeldung.meldungsstatus": "Statut de l'avis",
  "grundbuchmeldung.meldungsstatus.ERSTELLT": "Créé",
  "grundbuchmeldung.meldungsstatus.FEHLERHAFT_ERSTELLT": "Créé de manière incorrecte",
  "grundbuchmeldung.meldungsstatus.FEHLERHAFT_GESENDET": "Erreur d'envoi",
  "grundbuchmeldung.meldungsstatus.GESENDET": "Envoyé",
  "grundbuchmeldung.meldungsstatus.NICHT_ERSTELLT": "Non créé",
  "grundbuchmeldung.reset": "Réinitialiser l'envoi",
  "grundbuchmeldung.search.breadcrumb": "Avis du registre foncier",
  "grundbuchmeldung.suche": "Recherche",
  "grundbuchmeldung.tooltip": "Afficher avis du RF",
  "grundbuchmeldung_": "grundbuchmeldung_",
  "grundbuchmeldungen.ListTitel": "Avis trouvés",
  "grundstueck.ListTitel": "Les immeubles trouvés",
  "grundstueck.SucheTitel": "Recherche par immeubles",
  "grundstueck.eigentum.Bemerkungen": "Observations",
  "grundstueck.eigentum.DominierendesGrundstueck": "Immeuble dominant",
  "grundstueck.eigentum.ExterneHinweise": "Indications externes",
  "grundstueck.rubrik.AlleDaten": "Affichage de toutes les données du registre foncier",
  "grundstueck.rubrik.Anmerkungen": "Mentions",
  "grundstueck.rubrik.BeschreibendeDaten": "Données descriptives",
  "grundstueck.rubrik.Dienstbarkeiten": "Servitudes",
  "grundstueck.rubrik.Eigentum": "Propriété (Selon le registre foncier)",
  "grundstueck.rubrik.Grundlasten": "Charges foncières",
  "grundstueck.rubrik.Grundpfandrechte": "Droits de gage",
  "grundstueck.rubrik.Grundstueckbeschreibung": "Description de l'immeuble",
  "grundstueck.rubrik.HaengigeGeschaefte": "Affaires",
  "grundstueck.rubrik.OeffentlicheAnmerkungen": "Mentions ouvertes au public",
  "grundstueck.rubrik.Oereb": "Cadastre RDPPF",
  "grundstueck.rubrik.Rangregelung": "Rapport de rang",
  "grundstueck.rubrik.Vormerkungen": "Annotations",
  "grundstueck.search.breadcrumb": "Recherche par immeubles",
  "grundstueck.subnav.Anmerkungen": "Mentions",
  "grundstueck.subnav.BeschreibendeDaten": "Données descriptives",
  "grundstueck.subnav.Dienstbarkeiten": "Servitudes",
  "grundstueck.subnav.Eigentum": "Propriété",
  "grundstueck.subnav.GrundbuchVermessung": "Registre foncier/Mensuration",
  "grundstueck.subnav.Grundlasten": "Charges foncières",
  "grundstueck.subnav.Grundpfandrechte": "Droit de gage",
  "grundstueck.subnav.GwrObjekte": "Registre des bâtiments et logements",
  "grundstueck.subnav.HaengigeGeschaefte": "Affaires",
  "grundstueck.subnav.OerebKataster": "Cadastre RDPPF",
  "grundstueck.subnav.Rangregelungen": "Rapport de rang",
  "grundstueck.subnav.Uebersicht": "Vue d'ensemble",
  "grundstueck.subnav.Vormerkungen": "Annotations",
  "grundstueck.subnav.neskoab": "Évaluation officielle externe",
  "grundstueckHeading": "Immeuble",
  "grundstueckflaeche": "Surface de l'immeuble",
  "gueltig": "Valide",
  "gwr-link.tooltip": "Afficher les détails sur  EGID {{egid}} dans RegBL",
  "gwr.EingabeMussGueltigeStrasseSein": "La rue peut contenir un maximum de 60 caractères",
  "gwrBauprojekt.BreadcrumbSuche": "Projet de construction RegBL",
  "gwrBauprojekt.SucheTitel": "Recherche de projets de construction RegBL",
  "gwrGebaeude.BreadcrumbSuche": "Bâtiment RegBL",
  "gwrGebaeude.SucheTitel": "Recherche par bâtiments RegBL",
  "gültigAbSteuerjahr": "Valable à partir de l'année fiscale",
  "handelsangabenZu": "Informations commerciales sur l'",
  "historisiert": "historisé",
  "illegalObjectState": "illegalObjectState",
  "imNachgangZu": "Primé par :",
  "inbox.new-message": "Il y a des messages non lus dans votre boîte électronique",
  "inbox.notification.title": "Ouvrir la notification dans une nouvelle fenêtre",
  "inbox.open": "Ouvrir la boîte électronique",
  "inbox.open.title": "Ouvrir la boîte électronique dans une nouvelle fenêtre",
  "inbox.title": "Boîte électronique",
  "invalidrequest.title": "demande non valable",
  "kanton": "Canton",
  "kompakt": "compacte",
  "kreisNummer": "N° d'arrondissement",
  "kuerzel": "Abréviation",
  "layouts.GeschichteEinAus": "Histoire on/off",
  "layouts.emailAendern": "Changer d'e-mail",
  "layouts.entwicklungsUmgebung": "Environnement de développement",
  "layouts.notAutorizedTitle": "L'autorisation a échoué: l'user connecté n'est pas autorisé dans {{appTitle}}.",
  "layouts.page.title": "Intercapi",
  "layouts.page.titleNavigation": "Intercapi navigation",
  "layouts.passwortAendern": "Changer mot de passe",
  "layouts.settings": "Cadres",
  "layouts.testUmgebung": "Environnement de test",
  "layouts.toolbar.de": "DE",
  "layouts.toolbar.fr": "FR",
  "maps.anzeigePlan": "Afficher plan",
  "maps.anzeigePlanZu": "Afficher plan pour",
  "maps.exception.errorPageTitle": "Erreur lors de l'appel du plan dans le système externe {{fremdsystem}}.",
  "maps.exception.geo_link.allGrundstueckeNotFound": "Les immeubles que vous recherchez ne peuvent pas être affichés dans le plan pour le moment.",
  "maps.exception.geo_link.authorizationFailed": "Vous n'êtes pas autorisé à afficher ce plan. Veuillez vous inscrire auprès de Grudis.",
  "maps.exception.geo_link.errorMessage": "Une erreur technique s'est produite. Malheureusement, le plan ne peut pas être affiché.",
  "maps.exception.geo_link.gemeindeNotFound": "La commune/l'arrondissement ne peut pas être affiché sur le plan pour le moment.",
  "maps.exception.geo_link.grundstueckNotFound": "L'immeuble que vous recherchez ne peut pas être affiché sur le plan. Il n'y a pas de données géométriques numériques disponibles. Voulez-vous afficher le plan de la commune/de l'arrondissement ?",
  "maps.exception.geo_link.invalidRequest": "L'appel du plan n'est pas valable. Si cela se produit de manière répétée, veuillez contacter votre administrateur.",
  "maps.exception.topomaps.authorizationFailed": "Vous n'êtes pas autorisé à afficher ce plan. Veuillez vous inscrire auprès de Grudis.",
  "maps.exception.topomaps.errorMessage": "Il s'est produit une erreure technique. Il n'est pas possible d'afficher le plan.",
  "maps.exception.topomaps.invalidRequest": "L'appel du plan n'est pas valable. Si cela se produit de manière répétée, veuillez contacter votre administrateur.",
  "mehrereNachfuehrungsgeometer": "Plusieurs géomètres-conservateur sont enregistrés pour cette commune, mais un seul peut être affiché",
  "meinGrundstueck.tooltip": "En raison de votre propriété, d'autres informations sur le immeuble sont visibles pour vous",
  "meineGrundstuecke.filter": "Filtre les immeubles",
  "meineGrundstuecke.titel": "Mes immeubles",
  "meldungAbschlussdatumHeading": "Date de clôture (validation)",
  "meldungEingangsdatumHeading": "Date d’inscription au journal",
  "meldungErwerberVeraeussererHeading": "Acquéreur/aliénateur",
  "meldungGebaeudeHeading": "Bâtiment",
  "meldungsempfaenger.bezeichnung": "Désignation",
  "meldungsempfaenger.bezeichnung.invalid": "La désignation ne doit pas être vide",
  "meldungsempfaenger.detail": "Destinataire de l'avis eCH",
  "meldungsempfaenger.ereignisse": "Reçoit uniquement les événements suivants",
  "meldungsempfaenger.ereignisse.AENDERUNG_ANMERKUNG": "Modification mention",
  "meldungsempfaenger.ereignisse.AENDERUNG_DIENSTBARKEIT": "Modification servitude",
  "meldungsempfaenger.ereignisse.AENDERUNG_EIGENTUM": "Modification de la part de propriètè",
  "meldungsempfaenger.ereignisse.AENDERUNG_GRUNDLAST": "Modification charge foncière",
  "meldungsempfaenger.ereignisse.AENDERUNG_LIG_SDR": "Modification bien-fonds ou DDP",
  "meldungsempfaenger.ereignisse.AENDERUNG_PFANDRECHT": "Modification droit de gage",
  "meldungsempfaenger.ereignisse.AENDERUNG_STW_MIT": "Modification part de copropriété",
  "meldungsempfaenger.ereignisse.AENDERUNG_VORMERKUNG": "Modification annotation",
  "meldungsempfaenger.ereignisse.LOESCHUNG_ANMERKUNG": "Radiation mention",
  "meldungsempfaenger.ereignisse.LOESCHUNG_DIENSTBARKEIT": "Radiation servitude",
  "meldungsempfaenger.ereignisse.LOESCHUNG_EIGENTUM": "Radiation part de propriété",
  "meldungsempfaenger.ereignisse.LOESCHUNG_GRUNDLAST": "Radiation charge foncière",
  "meldungsempfaenger.ereignisse.LOESCHUNG_LIG_SDR": "Radiation bien-fonds ou DDP",
  "meldungsempfaenger.ereignisse.LOESCHUNG_PFANDRECHT": "Radiation droit de gage",
  "meldungsempfaenger.ereignisse.LOESCHUNG_STW_MIT": "Radiation part de copropriété",
  "meldungsempfaenger.ereignisse.LOESCHUNG_VORMERKUNG": "Radiation annotation",
  "meldungsempfaenger.ereignisse.NEU_ANMERKUNG": "Nouvelle mention",
  "meldungsempfaenger.ereignisse.NEU_DIENSTBARKEIT": "Nouvelle servitude",
  "meldungsempfaenger.ereignisse.NEU_EIGENTUM": "Nouvelle part de propriété",
  "meldungsempfaenger.ereignisse.NEU_GRUNDLAST": "Nouvelle charge foncière",
  "meldungsempfaenger.ereignisse.NEU_LIG_SDR": "Nouveau bien-fonds ou DDP",
  "meldungsempfaenger.ereignisse.NEU_PFANDRECHT": "Nouveau droit de gage",
  "meldungsempfaenger.ereignisse.NEU_STW_MIT": "Nouvelle part de copropriété",
  "meldungsempfaenger.ereignisse.NEU_VORMERKUNG": "Nouvelle annotation",
  "meldungsempfaenger.erhaeltBaseDelivery": "Reçoit Basedelivery",
  "meldungsempfaenger.erhaeltVertraulicheDaten": "Reçoit des données confidentielles",
  "meldungsempfaenger.erhaeltmeldungen": "Reçoit des avis",
  "meldungsempfaenger.error.uniqueConstraint": "Une destinatiaire d'avis eCH existe déjà avec cet ID de destinataire",
  "meldungsempfaenger.gemeinde": "Limité aux communes suivantes",
  "meldungsempfaenger.hasMeldungen": "Le destinataire a des messages. La radiation n'est pas autorisée.",
  "meldungsempfaenger.list": "Destinataires d'avis eCH trouvés",
  "meldungsempfaenger.sedexid": "ID destinataires SEDEX",
  "meldungsempfaenger.sedexid.invalid": "L'ID du destinataire Sedex est invalide",
  "meldungsempfaenger.suche": "Recherche destinataire avis eCH",
  "modal.close": "Clôturer",
  "monat": "Mois",
  "monate": "Mois",
  "navigation.grundbuchmeldung": "Afficher avis du RF",
  "neskoab.AmtlicheBewertung": "Evaluation officielle",
  "neskoab.AmtlicherWert": "Valeur officielle",
  "neskoab.AmtlicherWertCHF": "Valeur officielle CHF",
  "neskoab.BasisRevision": "Révision de base",
  "neskoab.Eigentum/Verteiler": "Propriété/Répartition",
  "neskoab.EigentumVerteiler": "Propriété/Répartition (Selon l'évaluation officielle)",
  "neskoab.ErtragswertBGBB": "Valeur de rendement selon la LDFR",
  "neskoab.GueltigAbSteuerjahr": "Valable à partir de l'année fiscale",
  "neskoab.Mutationsdatum": "Date mutation",
  "neskoab.Mutationsgrund": "Motif de la modification",
  "neskoab.Nutzniesser": "Usufruitier/ière",
  "neskoab.Nutzniessung": "Usufruit",
  "neskoab.Objekte": "Objets",
  "neskoab.SucheTitel": "Recherche en fonction du droit spécial concernant l’évaluation officielle",
  "neskoab.Totalflaeche": "Surface totale",
  "neskoab.nichtVerfuegbar": "Le service de Nesko AB n'est pas disponible actuellement !",
  "neskoabSearch.search.breadcrumb": "NESKOAB",
  "nichtBearbeitet": "Non traité",
  "nichtDefiniert": "Non défini",
  "not.authorized": "Aucune autorisation",
  "notAutorizedLoginRedirect": "Prière de se reconnecter.",
  "notfount.title": "Aucun objet trouvé.",
  "null": "null",
  "oereb.KeineInformationenVorhanden": "Aucune information disponible",
  "oereb.KeineOderNochKeineDatenVorhanden": "Aucune donnée ou encore aucune donnée disponible",
  "oereb.auszugKompakt": "Extrait cadastre RDPPF",
  "oereb.datenVonGrundstueck:": "Données de l'immeuble de base :",
  "oereb.nichtVerfuegbar": "Le service du cadastre RDP n'est pas disponible actuellement !",
  "oereb.oerebsBetreffenGrundstueck": "Restrictions de droit public à la propriété foncière qui touchent l'immeuble",
  "oereb.oerebsBetreffenGrundstueckNicht": "Restrictions de droit public à la propriété foncière qui ne touchent pas l'immeuble",
  "oereb.oerebsKeineDatenVorhanden": "Restrictions de droit public à la propriété foncière pour lesquelles aucune donnée n'est disponible",
  "ohneGrundbuchbezug": "Sans référence au registre foncier",
  "optimistic-lock.modal.back": "Non, retour",
  "optimistic-lock.modal.body": "L'enregistrement n'est pas possible, car les données ont été modifiées entre-temps. Recharger les données ?",
  "optimistic-lock.modal.continue": "Oui, recharger",
  "optimistic-lock.modal.title": "Données modifiées",
  "person.SucheTitel": "Recherche des personnes bénéficiaires",
  "person.breadcrumbSuche": "Personnes bénéficiaires",
  "personDiffHint": "Inscription au registre foncier trouvée ayant des différents attributs par rapport à la personne de base.",
  "persongb.addresssperre": "Publication d'adresse bloquée",
  "persongb.auskunftssperre": "Informations sur la personne bloquée",
  "personstamm.GrundbuchBezug": "Référence RF",
  "personstamm.ListTitel": "les personnes trouvées",
  "personstamm.SucheTitel": "Rechercher par personne",
  "personstamm.ZPVNummer": "No GCP",
  "personstamm.search.breadcrumb": "Personnes",
  "personstamm.tab.ZPVSuche": "Rechercher dans la GCP",
  "projektiert": "projeté",
  "publikation.ListTitel": "Publications retrouvées",
  "publikation.SucheTitel": "Recherche des publications",
  "publikation.search.breadcrumb": "Publications",
  "publikation.suche": "Recherche",
  "publikationAmtHeading": "Affaire du registre foncier",
  "publikationDateHeading": "Date de publication",
  "recht.search.breadcrumb": "Registre des droits",
  "rechte.SucheTitel": "Recherche des droits",
  "rechteId": "ID",
  "reset.check.modal.body": "Voulez-vous vraiment réinitialiser '{{entity}}' ?",
  "reset.check.modal.title": "Réinitialiser",
  "rolle": "Rôle",
  "saveSuccessMessage": "Changé avec succès.",
  "schnellsuche.help.attributes": "Les critères de recherche saisis sont validés contre les attributs de personnes suivants (autorisation appropriée supposée):",
  "schnellsuche.help.city": "NPA, lieu, n° du bâtiment et siège social seulement en combinaison avec d'auters critères",
  "schnellsuche.help.exact": "Les critères de recherche peuvent être encore restreints avec \"\". Les valeurs dans \"\" doivent être trouvées exactement. Les attributs suivantes peuvent être recherchées exactement de cette manière.",
  "schnellsuche.help.exact.addition": "Exemple: Mira \"Muster\" \"Zürich\"",
  "schnellsuche.help.fuzzy": "La recherche rapide ignore les caractères spéciaux et trouve les noms malgré d'une orthographe légèrement divergente. Les minuscules et majuscules sont ignorées.",
  "schnellsuche.help.order": "Les critères de recherche peuvent être saisis dans n'importe quel ordre.",
  "schnellsuche.help.suche": "La recherche des personnes cherche des inscriptions validées et historisées.",
  "search.noResults": "Aucun résultat",
  "searchOhneProjektstatusZeitrahmenUndGrundstuecknummer": "Lorsque vous effectuez une recherche avec le statut de projet \"Tous\", vous devez également rechercher la période ou le numéro de l'immeuble",
  "searchZeitrahmenOhneVonOderBis": "Lors d'une recherche avec un horizon temporel, les dates 'Du' et 'Au' doivent être spécifiées",
  "searchZuVieleSuchkriterien": "Les critères de recherche sont trop imprécis, veuillez les préciser.",
  "searchZuWenigSuchkriterien": "Les critères de recherche sont trop imprécis, veuillez les préciser.",
  "searchbar.nichtRegistriert": "Pour pouvoir utiliser cette fonction, vous devez vous connecter.",
  "searchbar.noResults": "Aucun immeuble trouvé",
  "searchbar.placeholderText": "Recherche par immeubles",
  "searchbar.searchingText": "Veuillez patienter...",
  "searchperson.noResults": "Aucune personne trouvée",
  "searchperson.placeholderText": "Rechercher une personne",
  "searchperson.searchingText": "Veuillez patienter...",
  "security.actionUrl": "Action",
  "security.adminHint": "Veuillez contacter votre administrateur.",
  "security.erweiterung": "Extension",
  "security.kanton": "Canton",
  "seit": "depuis",
  "select.all": "Sélectionner tous",
  "shared.breadcrumb.list": "Résultat de la recherche",
  "shared.logo.grundstueckInformationen": "Système d'information sur les données relatives aux immeubles",
  "stammperson-adresssperre": "Publication de l'adresse bloquée",
  "stammperson-adresssperre-mitBerechtigung": "Publication de l'adresse bloquée. Veuillez ne pas communiquer l'adresse à d'autres personnes.",
  "stammperson-auskunftsperre": "Information sur la personne bloquée",
  "stammperson-auskunftsperre-mitBerechtigung": "Information sur la personne bloquée. Veuillez ne pas communiquer ces données à d'autres personnes.",
  "stapelverarbeitung.search.breadcrumb": "Traitement par lots",
  "stichwortNichtVorhanden": "La recherche par mots-clés n'a donné aucun résultat",
  "stime.amtlicheBewertung": "Evaluation officielle",
  "stime.chf": "CHF",
  "stime.description": "Description",
  "stime.flaeche": "Surface (m²)",
  "stime.gebaeude": "Bâtiments",
  "stime.gesamtflaeche": "Surface totale m²",
  "stime.gesamtwert": "Valeur estimée totale",
  "stime.land": "Pays",
  "stime.schaetzung": "Valeur estimée (CHF)",
  "stime.validfrom": "Estimation calculée le",
  "successfullyLoggedOut": "Vous vous êtes déconnecté avec succès",
  "suche.status": "Statut",
  "sucheNachGeometergeschäften": "Recherche par affaire du/de la géomètre",
  "sucheNachGrundbuchgeschäften": "Recherche par affaire du registre foncier",
  "suchergebnis.EIGENTUEMER": "Propriétaires",
  "suchergebnis.GLAEUBIGER_SCHULDNER": "Créancier/ière - Débiteur/débitrice",
  "suchergebnis.UEBRIGE_BERECHTIGTE": "Autres bénéficiaires",
  "suchergebnis.gemeinden.PolitischeGemeinde": "Commune politique",
  "telefax": "Fax :",
  "telefonnummer1": "N° de téléphone 1",
  "titel.detail.geometergeschaeft": "Affaires du cadastre",
  "titel.zentralePerson": "Personne central",
  "title.AmtlicheBewertung": "Valeur officielle",
  "title.AmtlicheVermessung": "Mensuration officielle",
  "title.Grundbuch": "Registre foncier",
  "tooltip.EIGENTUEMER": "Rapports de propriété pour {{person}}",
  "tooltip.GLAEUBIGER_SCHULDNER": "Rapports de créancier pour {{person}}",
  "tooltip.UEBRIGE_BERECHTIGTE": "Tous les rapports de droit pour {{person}}",
  "tooltip.detailsAuftrag": "Afficher les détails de la commande",
  "tooltip.detailsPersonGb": "Afficher détails de la personne RF.",
  "tooltip.detailsPersonStamm": "Afficher détails personne de base {{person}}.",
  "tooltip.detailsPersonZpv": "Afficher les détails de la personne GCP {{person}}.",
  "tooltip.meldungsempfaenger": "Afficher détails du destinataire de l'avis",
  "tooltipHandelsangaben": "Afficher détails pour les informations commerciales",
  "tooltipZusatzangaben": "Afficher détails pour les informations supplémentaires",
  "total": "Total",
  "true": "Oui",
  "uebersichtAmtlicheBewertungComponent": "Évaluation officielle",
  "uebersichtOerebPlaceHolderComponent": "Cadastre RDPPF",
  "uebrigeBerechtigungenImGrundbuch": "Autres autorisations dans le registre foncier",
  "undefined": "indéfini",
  "ungueltigeXmlDateiHochgeladen": "Le fichier XML téléchargé n'est pas valide.",
  "unscharfeSuche": "Recherche approximative",
  "unscharfeSucheTooltip": "Les caractères spéciaux/diacritiques sont ignorés dans tous les cas, n'importe l'état de cette option de recherche.",
  "unsupported.text": "L'action suivante n'est pas prise en charge car l'extension requise n'est pas active.",
  "unsupported.title": "Accès non pris en charge",
  "unterirdisch": "souterrain",
  "vergleichGbPersonZpvPerson": "Comparaison de l'inscription GCP avec inscription dans registre foncier",
  "version": "Version",
  "vertragsdaten.Eigentuemer": "Propriétaire",
  "vertragsdaten.RechtsgrundArt": "Type de titre de droit",
  "vertragsdaten.RechtsgrundArt.ANDERE": "Autres",
  "vertragsdaten.RechtsgrundArt.GRENZAENDERUNG_SPEZIAL": "Cas spéciaux modifications des limites",
  "vertragsdaten.RechtsgrundArt.HANDAENDERUNG_DRITTE": "Transfert de propriété entre tiers",
  "vertragsdaten.RechtsgrundArt.HANDAENDERUNG_EHEGATTEN": "Transfert de propriété entre époux",
  "vertragsdaten.RechtsgrundArt.HANDAENDERUNG_ERBEN": "Transfert de propriété à des héritiers ou sous héritiers",
  "vertragsdaten.RechtsgrundArt.HANDAENDERUNG_GESELLSCHAFTEN": "Transfert de propriété entre personnes morales",
  "vertragsdaten.RechtsgrundArt.HANDAENDERUNG_SPEZIAL": "Cas spéciaux de transfert de propriété",
  "vertragsdaten.RechtsgrundArt.SONSTIGE_SPEZIAL": "Autres cas spéciaux",
  "vertragsdatensatz": "Jeu de données de contrat",
  "vom": "du",
  "von": "de",
  "wurdeErfolgreichGeloescht": "a été supprimé avec succès",
  "wurdeErfolgreichGespeichert": "a éte changé avec succès",
  "zentraleNr": "No GCP",
  "zpv.MaximalResultWarning": "Résultat incomplet, trop de données trouvées. Limitez la recherche s.v.p.",
  "zpvService.nichtVerfuegbar": "Le service GCP n'est pas disponible actuellement !",
  "zusatzangabenZuVeraeusserer": "Informations supplémentaires sur l'aliénateur",
  "zustaendigerNachfuehrungsgeometer": "Géomètre-conservateur",
  "zustaendigesGrundbuchamt": "Bureau du registre foncier responsable",
  "{{label}} must be a valid date of the form 31.12.2018": "doit être une date valable sous la forme du 31.12.2018",
  "{{label}} required": "requis",
  "ÄnderungOhneGeschäft": "Modification sans affaire"
}